<template>
  <div class="flex column">
    <el-card>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item name="1">
          <template slot="title">
            <span class="boldTitle">INTRODUCCIÓN </span>
          </template>
          <!-- <div style="text-align: justify;"> -->
          <div style="text-align: justify">
            <p>
              La conformaci&oacute;n de esta Normativa Interna del Personal
              responde a la necesidad que posee
              <strong>TENNOS&nbsp;BUSINESS,</strong> de definir normas de
              convivencia y desempe&ntilde;o de los recursos humanos en
              atenci&oacute;n y respeto a la dignidad humana, las leyes
              laborales de nuestra Rep&uacute;blica, a la condici&oacute;n&nbsp;
              y naturaleza de la empresa, as&iacute; como perfiles,&nbsp;
              objetivos, demandas y responsabilidades de los puestos de trabajo
              de nuestra organizaci&oacute;n. Como empresa en permanente
              desarrollo necesitamos definir los c&oacute;digos de conducta
              esperados de nuestro personal; por ello, se plantean en el
              presente documento las normativas m&aacute;s importantes que
              requerimos en el momento y, en lo adelante, ajust&aacute;ndonos a
              un modelo formal pero flexible de convivencia entre sus colabores.
              En el futuro, o cuando fuere necesario, se crear&aacute;n y
              aplicar&aacute;n las normativas extras que pudieran ser
              necesarias, o pertinentes, seg&uacute;n corresponda.
            </p>
            <p>
              Esperamos generar a lo interno y externo del Grupo, una
              atm&oacute;sfera sana, de respeto, integraci&oacute;n y
              gesti&oacute;n moderna que brinde con eficiencia, justicia,&nbsp;
              competencias t&eacute;cnicas y humanas, buen trato y
              motivaci&oacute;n para todos los empleados, relacionados, gerentes
              y directores de esta instituci&oacute;n, correspondi&eacute;ndose
              con nuestros ejes de actuaci&oacute;n y valores institucionales.

              <strong>TENNOS&nbsp;BUSINESS,</strong> puede convertirse en una
              organizaci&oacute;n de tecnolog&iacute;a modelo en el pa&iacute;s
              y fuera de este, siempre que logremos conformar un equipo &nbsp;de
              &nbsp;personas comprometidas con el buen desempe&ntilde;o y las
              buenas costumbres, fomentando la innovaci&oacute;n y creatividad
              propia a su naturaleza. Con un futuro&nbsp; promisorio,&nbsp; les
              invitamos a responsabilizarse para el logro de todos nuestros
              objetivos organizacionales.
            </p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <span class="boldTitle">ALCANCE Y EXCLUSIONES: </span>
          </template>
          <div style="text-align: justify">
            <p>
              Este documento es de cumplimiento obligatorio para todo el
              personal activo y contratistas de
              <strong>TENNOS&nbsp;BUSINESS,</strong> ha sido redactado en
              respeto y apego a las leyes nacionales y ser&aacute; revisado cada
              a&ntilde;o para garantizar su actualizaci&oacute;n Se excluyen del
              cumplimiento a clientes y relacionados que poseen sus propios
              documentos normativos, sin embargo se reserva el derecho de
              negociar con personas, organismos u organizaciones cuya
              filosof&iacute;as o accionar se contrapongan con las nuestras.
            </p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="5">
          <template slot="title">
            <span class="boldTitle">DESCRIPCION DE TENNOS BUSINESS: </span>
          </template>
          <div style="text-align: justify">
            <p>
              <span
                >Tennos Business es una compa&ntilde;&iacute;a formada por
                profesionales de distintas &aacute;reas de la tecnolog&iacute;a
                en la Rep&uacute;blica dominicana, con una experiencia acumulada
                que supera los 20 a&ntilde;os en el dise&ntilde;o,
                integraci&oacute;n, implementaci&oacute;n y mantenimiento de
                soluciones tecnol&oacute;gicas hechas a la medida.</span
              >

              Ofrecemos productos, servicios y soluciones tecnol&oacute;gicas
              apoyados en marcas de clase mundial. Como resultado contamos con
              recursos humanos altamente calificados y por encima de todo
              apoyados en una cultura de servicio al cliente que garantizan una
              experiencia extraordinaria de soporte post venta.
            </p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <span class="boldTitle">ELEMENTOS EMPRESARIALES:: </span>
          </template>
          <div style="text-align: justify">
            <h3><span>MISI&Oacute;N.</span></h3>
          </div>
          <div style="text-align: justify">
            Ofrecemos soluciones tecnológicas que agregan valor a nuestros
            clientes.
          </div>
          <div style="text-align: justify">
            <h3><span>VISI&Oacute;N</span></h3>
          </div>
          <div style="text-align: justify">
            <p>
              Somos una empresa lider en soluciones tecnológicas, comprometidos
              con brindar servicio en excelencia a nuestos clientes.
            </p>
          </div>
          <div style="text-align: justify">
            <h3>VALORES.</h3>
          </div>
          <div style="text-align: justify">
            <ul>
              <li>Equipo</li>
              <li>Innovaci&oacute;n</li>
              <li>Integridad</li>
              <li>Liderazgo</li>
              <li>Responsabilidad</li>
            </ul>
          </div>
        </el-collapse-item>

        <el-collapse-item name="4">
          <template slot="title">
            <span class="boldTitle">POLÍTICA DE LA CALIDAD: </span>
          </template>
          <div style="text-align: justify">
            En <strong>TENNOS&nbsp;BUSINESS,</strong> estamos comprometidos con
            proveer soluciones y servicios tecnológicos que satisfagan las
            necesidades y expectativas de nuestros clientes y partes
            interesadas, cumpliendo con los requisitos legales y reglamentarios
            aplicables, gestionando los riesgos y mejorando los procesos de
            manera continua, a través de la eficacia del sistema de gestión de
            la calidad.
          </div>
        </el-collapse-item>
        <el-collapse-item name="7">
          <template slot="title">
            <span class="boldTitle"
              >REGLAMENTO INTERNO Y POLÍTICAS DEL PERSONAL:
            </span>
          </template>
          <div style="text-align: justify">
            <ul>
              <el-collapse v-model="activeName1" accordion>
                <li>
                  <el-collapse-item name="8">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 1. Ambiente de Oficina
                      </span>
                    </template>
                    <div style="text-align: justify">
                      <p>
                        Como empresas de servicios, ejecutora de actividades y
                        proyectos tecnol&oacute;gicos varios,
                        <strong>TENNOS&nbsp;BUSINESS,</strong> est&aacute;
                        orientadas a brindar servicios de calidad, sujetos a
                        normas y est&aacute;ndares de eficiencia y buen
                        servicio, cuyas caracter&iacute;sticas pueden apreciarse
                        en el desarrollo de cada una de los compromisos y
                        trabajos asumidos. Es por esta raz&oacute;n que los
                        empleados de
                        <strong>TENNOS&nbsp;BUSINESS,</strong> deben colaborar
                        en el sostenimiento de la filosof&iacute;a de nuestra
                        cultura organizacional, manifestado desde el orden y
                        aspecto del local, hasta el logro de la eficacia,
                        eficiencia, rapidez y calidad de nuestros servicios. Es
                        responsabilidad de todos los empleados de
                        <strong>TENNOS&nbsp;BUSINESS,</strong> velar por
                        mantener un ambiente agradable, de respeto y acorde con
                        nuestra imagen corporativa, durante sus horas de
                        trabajo, y hasta despu&eacute;s de la jornada.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>El ambiente de las
                        oficinas est&aacute; caracterizado por:
                      </p>
                      <ul>
                        <li>
                          Entrada bordeada por jardineras laterales y
                          escal&oacute;n, con puerta de cristal de dos hojas,
                          que da acceso al edificio.
                        </li>
                        <li>
                          Parqueo para veh&iacute;culos en el frente del
                          edificio y otro de forma lateral a &eacute;ste.
                        </li>
                        <li>
                          Aire acondicionado en todas las &aacute;reas, que
                          permanecen&nbsp; encendidos&nbsp; s&oacute;lo durante
                          el horario de trabajo, jornada extendida laboral
                          exceptuando datacenter u otras &aacute;reas
                          cr&iacute;ticas necesarias para su funcionamiento.
                        </li>
                        <li>
                          &Aacute;rea de Recepci&oacute;n con sof&aacute;s para
                          visitantes.
                        </li>
                        <li>
                          Oficinas en colores de acuerdo a la naturaleza de la
                          empresa.
                        </li>
                        <li>
                          Acceso restringido a las &aacute;reas sensibles.
                        </li>
                        <li>
                          Cuadros que se asocian a dise&ntilde;os, equipos y
                          materiales de tecnolog&iacute;a o asociadas al
                          &aacute;rea
                        </li>
                      </ul>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Responsabilidades
                        sobre el ambiente f&iacute;sico del trabajo:
                      </p>
                      <ul>
                        <li>
                          En las &aacute;reas de trabajo se debe evitar colocar
                          m&uacute;sica que interfiera con el ambiente de
                          trabajo, que alteren la concentraci&oacute;n y
                          sobriedad de las&nbsp;oficinas
                        </li>
                        <li>
                          Mantener el tono de voz adecuado en la oficina,
                          evitando gritar en los pasillos, hablando en voz baja,
                          evitando carcajadas, chistes, u otros modelos de
                          conversaci&oacute;n estridente, o mantener
                          conversaciones grupales que distraigan la
                          atenci&oacute;n de los que trabajan. Estas conductas
                          son consideradas como falta leve a las
                          pol&iacute;ticas conductuales de la empresa.
                        </li>
                        <li>
                          Es deber de todo empleado, velar por mantener su
                          &aacute;rea de trabajo en condiciones &oacute;ptimas.
                        </li>
                        <li>
                          Es pol&iacute;tica institucional que el personal vele
                          por el orden y limpieza de las &aacute;reas comunes,
                          tales como escaleras, ba&ntilde;os, cocina, comedor,
                          pasillos, evitando dejar documentos, equipos, piezas,
                          o materiales esparcidos por las &aacute;reas de
                          trabajo, sobre todo las que no le le pertenecen.
                        </li>
                        <li>
                          Cada empleado es responsable de apagar las luces y
                          aire acondicionado, o bien, desconectar los equipos
                          que le han sido asignados, a la hora en que finalicen
                          sus labores.
                        </li>
                        <li>
                          Las instalaciones de
                          <strong>TENNOS&nbsp;BUSINESS,</strong> como
                          compa&ntilde;&iacute;a de tecnolog&iacute;a,
                          caracterizada por trabajos e instalaciones &nbsp;de
                          programas, servicios e implementaciones complejas,
                          declara que&nbsp; su&nbsp; imagen debe amparar esta
                          naturaleza; por lo que el ambiente debe ser cuidado
                          con pulcritud, en este sentido todos los empleados son
                          responsables del cumplimiento a cabalidad de esta
                          norma, manifestando completo respeto a la imagen
                          corporativa. La desobediencia de estos aspectos,
                          implica despido autom&aacute;tico de la empresa.
                        </li>
                        <li>
                          Los tonos en los celulares, as&iacute; como los avisos
                          de mensajes, WhatsApp u otros, deben ser
                          institucionales, suaves y al nivel de volumen adecuado
                          a las oficinas que no interfiera con el trabajo del
                          compa&ntilde;ero
                        </li>
                        <li>
                          Las &aacute;reas personales de oficina deben estar
                          orientadas a mantener el decoro, el respeto y apego a
                          las buenas costumbres, por ello queda prohibida la
                          colocaci&oacute;n de protectores de pantallas en la
                          pc, fotos u otros adornos alejados de esta norma,
                          aunque se permite la personalizaci&oacute;n moderada
                          de su espacio, con fotos familiares, u otros, que no
                          rompan el estilo de la&nbsp;empresa.
                        </li>
                        <li>
                          Es responsabilidad de cada colaborador dar aviso sobre
                          el funcionamiento de los equipos y sistemas a su
                          cargo, o bien, del uso y cuidado que
                        </li>
                        <li>
                          La decoraci&oacute;n general debe ser oficial, y queda
                          bajo la responsabilidad de la persona que ostenta el
                          cargo de Servicios Generales de la empresa.
                        </li>
                        <li>
                          El acceso a las diversas &aacute;reas de la empresa,
                          queda bajo la reglamentaci&oacute;n de los controles
                          de acceso que se utilizan, aunado a las
                          responsabilidades y tareas relacionadas con el puesto
                          de trabajo que desempe&ntilde;an.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="9">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 2. Apertura y Cierre de las Oficina
                      </span>
                    </template>
                    <div style="text-align: justify">
                      <p>
                        Por la naturaleza de la compa&ntilde;&iacute;a, las
                        personas responsables del manejo de las llaves del
                        edificio, pertenecen a un nivel jer&aacute;rquico, y son
                        las responsables de abrir y/o cerrar las instalaciones;
                        de esa forma garantizamos la permanente seguridad del
                        local. Esta responsabilidad es del Encargado de la
                        Seguridad, para ello dispone de un juego de llaves.
                      </p>
                      <p>
                        Asimismo, siempre podr&aacute;n solicitar la apertura de
                        la empresa, en cualquier momento u hora:
                      </p>
                      <ul>
                        <li>Director General</li>
                        <li>Directores, Gerentes, y/o Encargados</li>
                      </ul>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Apertura de la
                        Oficina
                      </p>
                      <p>
                        La apertura se establece a las 6:30 am, para iniciar las
                        labores se dispone de las&nbsp; llaves de la puerta de
                        cristal principal. Una vez est&eacute;n abiertas,
                        s&oacute;lo deben encenderse las luces y los aires
                        acondicionados de las &aacute;reas de trabajo que lo
                        requieran, con el fin de ahorrar energ&iacute;a.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Cierre de la oficina
                      </p>
                      <p>
                        Al final del d&iacute;a o en el momento en que se
                        requiera, los empleados, deber&aacute;n asegurarse que
                        en las &aacute;reas de trabajo todo haya sido
                        debidamente apagado y&nbsp; de&nbsp; forma adecuada,
                        velando por la correcta seguridad f&iacute;sica de cada
                        una de las oficinas.
                      </p>
                      <p>
                        El empleado encargado de cerrar la oficina ser&aacute;
                        aquel &uacute;ltimo en abandonar el departamento, y
                        deber&aacute;:
                      </p>
                      <ul>
                        <li>Verificar que se hayan apagado todas las luces.</li>
                        <li>Apagar los aires acondicionados.</li>
                      </ul>
                      <p>
                        El personal encargado de cerrar la empresa deber&aacute;
                        asegurarse de:
                      </p>
                      <ul>
                        <li>Verificar que se hayan apagado todas las luces.</li>
                        <li>Apagar los aires acondicionados.</li>
                        <li>
                          Verificar el cierre de las llaves de agua del local.
                        </li>
                        <li>
                          Verificar que todo este adecuadamente asegurado.
                        </li>
                        <li>
                          Constatar la presencia de la seguridad de la empresa.
                        </li>
                      </ul>
                      <p>
                        El incumplimiento de esta pol&iacute;tica es causal de
                        despido, por la falta de cuidado sobre el patrimonio de
                        la empresa, acogi&eacute;ndonos al Art&iacute;culo 88
                        del C&oacute;digo Laboral.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="10">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 3. Asignación de los parqueos
                      </span>
                    </template>
                    <div style="text-align: justify">
                      <p>
                        Para garantizar el debido orden, el respeto y
                        aprovechamiento de los espacios de parqueos de la
                        empresa, se asignan los parqueos, de acuerdo a la
                        jerarqu&iacute;a de los cargos que ocupa el colaborador;
                        Durante el primer mes de cada a&ntilde;o esta
                        asignaci&oacute;n es revisada por la Gerencia de Capital
                        Humano, de acuerdo a los cambios que pudieran
                        presentarse en el organigrama de la empresa. Por razones
                        de seguridad los parqueos ser&aacute;n rotulados
                        s&oacute;lo con las especificaciones empleado/visitante,
                        y debe el seguridad de turno avisar cuando alguien ocupe
                        alg&uacute;n estacionamiento que no le corresponda.
                        Igualmente la conducta del personal deber&aacute;
                        mantenerse al nivel de madurez exigida, ante la
                        ocupaci&oacute;n del estacionamiento que se le haya
                        asignado, declarando el hecho al &aacute;rea de Capital
                        Humano, a los fines de que fuere resuelto, a la mayor
                        brevedad. Con el objetivo de esclarecer la
                        asignaci&oacute;n, se anexa a &eacute;ste reglamento el
                        &uacute;ltimo plano de parqueos en vigencia para la
                        organizaci&oacute;n. El personal de Capital Humano
                        notificar&aacute; a los involucrados los cambios y
                        actualizar&aacute; en el anexo los ajustes que pudieran
                        derivarse.
                      </p>
                      <p>
                        El incumplimiento de estas directrices, ser&aacute;
                        sancionado.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="11">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 4. Asistencia, Puntualidad y Permanencia
                      </span>
                    </template>
                    <div>
                      <p>
                        El personal que labora en
                        <strong>TENNOS&nbsp;BUSINESS,</strong> tiene la
                        obligaci&oacute;n de cumplir con las disposiciones que
                        sobre asistencia, puntualidad y permanencia en el
                        trabajo se declaran, para alcanzar y mantener el buen
                        desenvolvimiento y desempe&ntilde;o de las actividades
                        propias de esta organizaci&oacute;n.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Control de Asistencia
                      </p>
                      <p>
                        EL control de la asistencia es a trav&eacute;s de un
                        sistema autom&aacute;tico de registro. La Gerencia de
                        Capital Humano es el encargado de registrar la huella
                        digital y/o&nbsp; el pase de acceso en el control
                        electr&oacute;nico de asistencia a cada personal de la
                        empresa. Los empleados tienen la obligaci&oacute;n de
                        realizar 4 ponches al d&iacute;a, correspondiente a:
                        hora de llegada a la empresa, hora de salida al
                        almuerzo, hora de llegada de almuerzo y hora de salida o
                        de finalizaci&oacute;n de la jornada, exceptuando el
                        personal que tenga realice servicio con los clientes o
                        proveedores fuera de la empresa. Los empleados que no
                        realicen el ponche y no se registre en el sistema
                        ser&aacute; tomado como ausencia.
                      </p>
                      <p>
                        La Gerencia de Capital Humano publicara en el portal
                        administrativo el registro de la asistencia diariamente,
                        con el fin de llevar el control de la asistencia y
                        tardanzas del personal, el cual servir&aacute; de
                        soporte para cualquier llamado de atenci&oacute;n.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Ausencia
                        injustificada
                      </p>
                      <p>
                        Es obligaci&oacute;n del trabajador dar aviso a su
                        supervisor inmediato, acerca de la causa que le impide
                        asistir a su trabajo, seg&uacute;n lo establece el
                        art&iacute;culo #58 del C&oacute;digo de Trabajo. Esta
                        raz&oacute;n debe notificarse por escrito a Capital
                        Humano a trav&eacute;s de un documento evidencia, ya sea
                        certificado m&eacute;dico, permiso de salida, asistencia
                        a eventos, u otros. Incumplir con esta
                        disposici&oacute;n le significar&aacute; un reporte de
                        inasistencia como injustificada.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3: </strong>Permanencia laboral
                      </p>
                      <p>
                        Se deja constar, que en aquellos casos en que un
                        empleado faltare a sus&nbsp; labores durante dos (2)
                        d&iacute;as consecutivos, o dos (2) d&iacute;as dentro
                        de un mismo mes, (Art&iacute;culo 88, Ordinal 11, CT)
                        sin notificar la causa justa que tuvo para ello, dentro
                        del plazo prescrito por el art&iacute;culo 58 del
                        C&oacute;digo de Trabajo,
                        <strong>TENNOS&nbsp;BUSINESS,</strong> &ldquo;<em
                          >puede sustituirlo sin que el trabajador tenga derecho
                          a reclamar ni su restituci&oacute;n, ni pago de sus
                          prestaciones laborales</em
                        ><em>&rdquo;</em>. Todo esto bajo el amparo de lo
                        establecido en la legislaci&oacute;n laboral dominicana.
                      </p>
                      <p></p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="12">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 5. Bonificación y Regalía Pascual
                      </span>
                    </template>
                    <div>
                      <p>
                        El a&ntilde;o fiscal de la empresa finaliza el 31 de
                        diciembre de cada a&ntilde;o y los beneficios
                        adquiridos, siempre que exista, durante ese
                        per&iacute;odo ser&aacute;n entregados a sus
                        beneficiarios, en proporci&oacute;n del 10% establecido
                        por la Ley, para todo el personal y hasta 120
                        d&iacute;as despu&eacute;s que se cumple,
                        aproximadamente en el mes de abril. As&iacute; mismo, en
                        el caso espec&iacute;fico de la regal&iacute;a
                        pascual<em>, </em>el pago se&nbsp; efectuar&aacute;
                        apeg&aacute;ndonos estrictamente a&nbsp; lo establecido
                        por las leyes dominicanas, consistente en la
                        duod&eacute;cima parte del salario ordinario devengado
                        por el trabajador en el a&ntilde;o calendario, y puede
                        ser pagada hasta el 20 de Diciembre de cada a&ntilde;o.
                        Para el pago de este salario se excluyen las
                        retribuciones por horas extraordinarias y el salario
                        correspondiente a la participaci&oacute;n en los
                        beneficios de la empresa, as&iacute; como tambi&eacute;n
                        los beneficios marginales. El salario de navidad no
                        ser&aacute; computado para los fines del preaviso ni de
                        la cesant&iacute;a. El trabajador que no haya prestado
                        servicios durante todo el a&ntilde;o tiene derecho al
                        salario de navidad en proporci&oacute;n al tiempo
                        trabajado durante el a&ntilde;o, seg&uacute;n lo
                        establece el Art. 220 del c&oacute;digo de trabajo.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="13">
                    <template slot="title">
                      <span class="boldTitle">Artículo 6. Botiquín </span>
                    </template>
                    <div>
                      <p>
                        La empresa es responsable de velar por la integridad
                        f&iacute;sica de sus trabajadores, por lo que establece
                        la ubicaci&oacute;n de:
                      </p>
                      <ol>
                        <li>
                          Un Botiqu&iacute;n completo en el primer nivel de la
                          Oficina.
                        </li>
                        <li>
                          Un peque&ntilde;o botiqu&iacute;n port&aacute;til, en
                          cada uno de los veh&iacute;culos de la empresa tal y
                          como establece la Ley 241, sobre tr&aacute;nsito.
                        </li>
                      </ol>
                      <p>
                        Para disponer de los contenidos de dicho
                        botiqu&iacute;n, el personal deber&aacute; solicitarlo a
                        Capital Humanos con detalles del malestar y del
                        medicamento. El contenido del Botiqu&iacute;n
                        ser&aacute; repuesto a solicitud del &aacute;rea de
                        Capital Humanos, en el plazo que la demanda del servicio
                        pueda tener. (Lista de contenidos del Botiqu&iacute;n).
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="14">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 7. Capacitación y Desarrollo del Personal
                      </span>
                    </template>
                    <div>
                      <p>
                        Las empresas del grupo podr&iacute;an costear cursos de
                        capacitaci&oacute;n a su personal, cuando sea pertinente
                        al inter&eacute;s de la empresa y sea solicitado con un
                        m&iacute;nimo de quince (15) d&iacute;as laborables,
                        seg&uacute;n las propuestas y aprobaci&oacute;n del
                        Encargado de &aacute;rea, necesidades y pertinencia de
                        la capacitaci&oacute;n; o bien, que haya sido
                        contemplado en el plan de capacitaci&oacute;n del
                        a&ntilde;o. La aprobaci&oacute;n del porcentaje cubierto
                        por la empresa con relaci&oacute;n a la
                        capacitaci&oacute;n ser&aacute; determinada siempre que
                        el presupuesto de capacitaci&oacute;n lo permita. El
                        personal que haya sido capacitado por la empresa
                        deber&aacute; firmar un acuerdo de permanencia. En el
                        cual tiene el compromiso de permanecer en la empresa
                        durante un per&iacute;odo de seis meses a dos
                        a&ntilde;os, contando a partir de la fecha de
                        t&eacute;rmino de la capacitaci&oacute;n, seg&uacute;n
                        los gastos relacionados a la misma.
                      </p>
                      <p>
                        Si el trabajador decidiese retirarse del empleo antes de
                        finalizar el acuerdo, este deber&aacute; cubrir hasta el
                        50% de la capacitaci&oacute;n obtenida en el
                        &uacute;ltimo a&ntilde;o. Los programas y actividades de
                        formaci&oacute;n que podr&aacute; cubrir la empresa
                        incluyen programas t&eacute;cnicos, de grado y
                        post-grado, siempre que el trabajador cumpla con los
                        siguientes requisitos:
                      </p>
                      <ul>
                        <li>
                          Tener por lo menos un a&ntilde;o de antig&uuml;edad en
                          cualquiera de la empresa.
                        </li>
                        <li>
                          Poseer un comportamiento y evaluaci&oacute;n del
                          desempe&ntilde;o m&iacute;nimo de &ldquo;Bueno&rdquo;.
                        </li>
                        <li>
                          Mantener un &iacute;ndice acad&eacute;mico A/B en
                          promedio o el equivalente a las mismas.
                        </li>
                        <li>
                          El curso o formaci&oacute;n solicitada debe ir
                          relacionada con el puesto de trabajo que se ocupa y la
                          naturaleza de la empresa.
                        </li>
                      </ul>
                      <p>
                        <span
                          >El empleado mismo y su superior inmediato
                          podr&aacute;n solicitar alguna actividad de
                          formaci&oacute;n </span
                        >llenando el Formulario &ldquo;Solicitud de Actividad
                        Formativa&rdquo;
                      </p>
                      <p></p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="15">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 8. Ambiente de Oficina</span
                      >
                    </template>
                    <div>
                      <p>
                        <strong>TENNOS&nbsp;BUSINESS,</strong> firma contratos
                        de trabajo para todos los contratistas que necesiten
                        realizar alguna labor o servicio para las empresas y sus
                        clientes. Mantenemos compromiso de forma legal y
                        directa, &uacute;nicamente con la Empresa Contratista y
                        su representante; por lo cual queda claro que no existe
                        ning&uacute;n compromiso ni relaci&oacute;n contractual
                        con los trabajadores subcontratados por &eacute;sta. El
                        contratista directo tiene en el momento del inicio de
                        los trabajos, que presentar un Listado del Personal que
                        laborar&aacute; en obras o proyectos con: Nombre y el
                        n&uacute;mero de c&eacute;dula de identificaci&oacute;n
                        del personal involucrado en la obra o servicio
                        adem&aacute;s de la copia de este documento.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>La Gerencia de
                        Capital Humano de <strong>TENNOS&nbsp;BUSINESS,</strong>
                      </p>
                      <p>
                        S.A. compondr&aacute; un archivo de trabajadores
                        sub-contratados frecuentes a los fines de conservar
                        expedientes de cada grupo de t&eacute;cnicos u obreros
                        por la empresa contratista, y solo renovar&aacute;
                        informaci&oacute;n cuando la contrataci&oacute;n sea
                        diferente.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Cada contratista es
                        responsable del comportamiento y desempe&ntilde;o del
                        personal a su cargo; Se les exige el uso de uniformes
                        del Contratista y Carn&eacute;ts de
                        identificaci&oacute;n de Contratista provisto por TENNOS
                        BUSINESS.
                      </p>
                      <p>
                        as&iacute; como tambi&eacute;n mantener un
                        comportamiento adecuado, conservando siempre limpia su
                        &aacute;rea de trabajo durante y despu&eacute;s de
                        ejecutar su labor, entregando los materiales de
                        identificaci&oacute;n y los resultados al concluir el
                        acuerdo.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3: </strong>Todos los reclamos de
                        obra de <strong>TENNOS&nbsp;BUSINESS,</strong>
                        recaen exclusivamente sobre el Contratista Directo,
                        quien tendr&aacute; en todos los casos, la
                        responsabilidad de responder y/o subsanar las
                        incidencias acordadas ante la empresa y el contrato
                        establecido. La Empresa se reserva el derecho de
                        intervenci&oacute;n por reclamos de este tipo de casos.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="16">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 9. Comportamiento de Personas que dan Servicio
                        (Subcontratadas)
                      </span>
                    </template>
                    <div>
                      <p>
                        El personal de las empresas contratistas o personas
                        independientes que brindan apoyo en la
                        realizaci&oacute;n de nuestras tareas, as&iacute; como
                        en el mantenimiento e instalaci&oacute;n de las
                        localidades de la empresa, un comportamiento acorde con
                        nuestras pol&iacute;ticas.
                      </p>
                      <p>Por lo tanto, se les requiere:</p>
                      <ul>
                        <li>
                          Acceder a las oficinas solo cuando su ingreso haya
                          sido autorizado, especialmente a las dependencias
                          administrativas, de adquisiciones, facturaci&oacute;n,
                          contabilidad, y almac&eacute;n.
                        </li>
                        <li>
                          Portar de manera visible en sus recorridos a las
                          instalaciones de la empresa, carnet de visita.
                        </li>
                        <li>
                          Recepci&oacute;n validar&aacute; la
                          identificaci&oacute;n de la persona antes de permitir
                          el pase a las oficinas y registrar&aacute;: Nombre,
                          hora de ingreso, hora de salida, c&eacute;dula de
                          identidad, organizaci&oacute;n que representa,
                          &aacute;rea a visitar, y le hace firmar en la hora de
                          salida del local.
                        </li>
                        <li>
                          No se permite la entrada a nuestras oficinas de
                          personas en estado de embriaguez, o bajo la influencia
                          del alcohol, drogas u otras sustancias.
                        </li>
                        <li>
                          No se permite el acceso de visitas a oficinas
                          administrativas ni comerciales, en todo caso el
                          colaborador que corresponda deber&aacute; salir de sus
                          oficinas y recibir en uno de los salones de reuniones,
                          o en su defecto en las &aacute;reas comunes de la
                          empresa.
                        </li>
                        <li>
                          Las visitas deber&aacute;n presentarse preferiblemente
                          uniformadas e identificadas, de ser posible, por la
                          instituci&oacute;n a la cual presta servicios.
                        </li>
                        <li>
                          No portar armas de fuego y/o armas blancas dentro de
                          las instalaciones de la empresa.
                        </li>
                        <li>
                          Apegarse a la prohibici&oacute;n de no fumar dentro de
                          las instalaciones de la empresa o de los clientes
                          finales.
                        </li>
                        <li>
                          Mantener un adecuado nivel de higiene personal durante
                          la ejecuci&oacute;n de sus trabajos, dentro de la
                          empresa o donde clientes finales.
                        </li>
                        <li>
                          Asistir a tiempo y debidamente identificado con carnet
                          de Contratista Magycorp, cuando trabaje en la
                          locaci&oacute;n en donde se ofrecen los servicios del
                          Cliente Final.
                        </li>
                        <li>
                          Utilizar implementos de seguridad en obra tales como:
                          cascos, lentes, guantes, correas, arn&eacute;s u otros
                          siempre que lo amerite.
                        </li>
                        <li>
                          Cumplir adem&aacute;s y siempre, todas las normas de
                          ejecuci&oacute;n e higiene industrial en las
                          localidades, lo que libera a
                          <strong>TENNOS&nbsp;BUSINESS,</strong> de compromisos
                          ante cualquier eventualidad y/o accidente laboral en
                          las instalaciones de la obra en ejecuci&oacute;n
                          interna o donde clientes.
                        </li>
                        <li>
                          Cumplir efectivamente con las condiciones pautadas en
                          el contrato de servicios o acuerdo de trabajo
                          establecido, entregando todo al concluir la labor, con
                          la calidad requerida por la empresa y el cliente
                          final.
                        </li>
                        <li>
                          En caso de que sean compa&ntilde;&iacute;as, deben
                          abstenerse de contratar menores de edad, personas en
                          riesgo o vulnerabilidad y/o extranjeros ilegales, para
                          la realizaci&oacute;n de los trabajos.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="17">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 10. Comunicaciones Internas
                      </span>
                    </template>
                    <div>
                      <p>
                        Para coordinar los trabajos la comunicaci&oacute;n
                        interna, la empresa establece esta normativa con el
                        inter&eacute;s de que todo el personal cumpla
                        literalmente con lo dispuesto.
                      </p>
                      <p>
                        &nbsp;<strong>P&aacute;rrafo 1</strong>: Comunicaciones
                        Internas:
                      </p>
                      <p>
                        Los miembros de
                        <strong>TENNOS&nbsp;BUSINESS,</strong> se comunican
                        internamente utilizando los sistemas de
                        comunicaci&oacute;n establecidos tanto
                        f&iacute;sico&nbsp; o digital, pueden ser: circulares,
                        mensajes generales por correo electr&oacute;nico, por
                        Whatsapp, por el sistema administrativo, por notas
                        escritas por el solicitante o receptor o llamadas
                        telefonicas. En los casos de procedimientos, por medio
                        de los manuales oficiales, formularios, informes y
                        documentos establecidos para cada caso. por medio de los
                        manuales oficiales, formularios, informes y documentos
                        establecidos para cada caso. Toda comunicaci&oacute;n
                        interna ascendente debe hacerse v&iacute;a el superior
                        inmediato. Generando siempre una copia como evidencia,
                        fechada y firmada con el responsable para los registros.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="18">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 11. Comunicaciones Externas
                      </span>
                    </template>
                    <div>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Salida de
                        Comunicaciones:
                      </p>
                      <p>
                        Todas las comunicaciones externas de las empresas deben
                        estar debidamente identificadas con el logo corporativo
                        y en papel timbrado. Deben tener un n&uacute;mero, que
                        corresponda al registro en un cronol&oacute;gico
                        general. As&iacute; mismo, se debe conservar y archivar
                        en el departamento de origen, una copia recibida por el
                        receptor de todas las comunicaciones generadas para
                        fines de control interno. Las comunicaciones dirigidas a
                        clientes, siempre deben salir registradas en el
                        cronol&oacute;gico central y con copia para el recibo,
                        con logo institucional&nbsp; del&nbsp; papel timbrado de
                        la empresa del grupo a la que haga referencia.
                        As&iacute; como firmadas por el Director General o
                        Encargados de la organizaci&oacute;n. El
                        cronol&oacute;gico de comunicaciones debe ser llevado
                        por la recepcionista de la empresa, y en el &aacute;rea
                        de Capital Humano se conserva un registro de
                        comunicaciones internas relativas al personal,
                        conservando archivo f&iacute;sico de cada una.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Entrada de
                        Comunicaciones:
                      </p>
                      <p>
                        Todas las comunicaciones externas deben ser recibidas
                        f&iacute;sicamente &nbsp;por &nbsp;la recepcionista y
                        tanto en la original recibida como en la copia de la
                        entrega, deber&aacute;n firmar y sellar en el momento de
                        la recepci&oacute;n con sello de recibido de la empresa,
                        donde aparece la fecha, la hora y el nombre de la
                        persona que ha recibido dicho documento. Cuando el
                        documento recibido sean facturas y /o cheques
                        &eacute;stos deben remitirse al Coordinador de
                        Adquisiciones. En caso de documentos legales deben
                        remitirse al responsable de los aspectos legales y
                        jur&iacute;dicos de la empresa En caso de entrega de
                        pedidos de mercanc&iacute;as, se realiza seg&uacute;n el
                        Procedimiento de Almacenamiento de materiales
                        MBG-GLO-PR-01 Las facturas, presupuestos, &oacute;rdenes
                        de compras, formulario de entrada y/o salidas y conduces
                        de clientes y proveedores o contratistas, deben
                        recibirse en las oficinas de
                        <strong>TENNOS&nbsp;BUSINESS,</strong> de forma
                        f&iacute;sica o digital, siempre que est&eacute;n
                        debidamente selladas y firmadas por el inc&uacute;mbete
                        principal y/o responsable de la negociaci&oacute;n; en
                        casos de utilizarse la forma digital. El Ejecutivo de
                        Ventas, velar&aacute; por conseguir la firma y/o
                        autorizaci&oacute;n expresa paralela para autenticar el
                        documento, aunque sea en el contrato de ventas.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="19">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 12. Deberes del Empleado
                      </span>
                    </template>
                    <div>
                      <p>
                        Todo contrato de trabajo conlleva deberes y
                        obligaciones, por consiguiente, para tener derecho a
                        reclamar y sustentar cualquier queja, el trabajador debe
                        cumplir las normas establecidas en la Legislaci&oacute;n
                        Dominicana a trav&eacute;s del C&oacute;digo de Trabajo,
                        adem&aacute;s de cumplir con los reglamentos internos
                        elaborados por
                        <strong>TENNOS&nbsp;BUSINESS,</strong> bajo los
                        requisitos se&ntilde;alados por el Ministerio de
                        Trabajo.&nbsp; Dentro de esas obligaciones citaremos las
                        de mayor relevancia.
                      </p>
                      <p>
                        Los Deberes de todos los empleados de Magycorp
                        <strong>TENNOS&nbsp;BUSINESS,</strong> son los
                        siguientes:
                      </p>
                      <ul>
                        <li>
                          Respetar, cumplir y hacer cumplir las leyes,
                          pol&iacute;ticas, reglamentos y las disposiciones
                          administrativas expedidas por la empresa.
                        </li>
                        <li>
                          Efectuar su trabajo con la intensidad, esmero y
                          cuidado apropiados, procurando cumplir
                          satisfactoriamente con las labores que les han sido
                          asignada
                        </li>
                        <li>
                          Acatar las &oacute;rdenes que les impartan sus
                          superiores inmediatos y efectuar las tareas
                          adicionales que les asignen, siempre que sean
                          compatibles con sus responsabilidades y funciones
                          propias de las empresas, seg&uacute;n su
                          descripci&oacute;n de puesto.
                        </li>
                        <li>
                          Utilizar las instalaciones comunes de forma adecuada y
                          en los &nbsp;tiempos asignados
                        </li>
                        <li>
                          Velar por la conservaci&oacute;n y buen estado de las
                          m&aacute;quinas, computadoras, mobiliarios,
                          &uacute;tiles, veh&iacute;culos o cualquier
                          herramienta, o instrumento de la empresa, no
                          pudi&eacute;ndolos usar para fines ajenos al trabajo,
                          y pagar por el deterioro, destrucci&oacute;n o
                          p&eacute;rdida que les sean imputadas por el mal&nbsp;
                          uso, descuido o negligencia de suparte
                        </li>
                        <li>
                          Mantener una conducta adecuada, caracterizada por
                          buenos modales y cortes&iacute;a con los clientes
                          internos, externos, prospectos, asociados, proveedores
                          y relacionados de la Tanto fuera y dentro de la
                          empresa.
                        </li>
                        <li>
                          Guardar la m&aacute;s absoluta reserva sobre los
                          asuntos oficiales de la empresa.
                        </li>
                        <li>
                          Presentarse al trabajo con la correcci&oacute;n y
                          decoro adecuado en el vestir y de acuerdo al puesto de
                          trabajo. Respetando el c&oacute;digo de vestimenta
                          establecido, como tambi&eacute;n lo botones y carnet.
                        </li>
                        <li>
                          Permitir la gesti&oacute;n de evaluaci&oacute;n
                          m&eacute;dica costeada en el laboratorio seleccionado
                          por la empresa.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="20">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 13. Derechos del Empleado</span
                      >
                    </template>
                    <div>
                      <p>
                        Los empleados de<strong>TENNOS&nbsp;BUSINESS,</strong>
                        gozar&aacute;n de TODOS los derechos y beneficios
                        establecidos por la Ley, y otros que se detallan&nbsp; a
                        continuaci&oacute;n:
                      </p>
                      <ul>
                        <li>
                          Derecho a recibir un trato respetuoso, &eacute;tico,
                          en apego a los derechos humanos y civiles que valoran
                          su dignidad.
                        </li>
                        <li>
                          Derecho a su individualidad e intimidad personal.
                        </li>
                        <li>
                          Derecho a la libre expresi&oacute;n, siempre que
                          &eacute;sta no lesione la integridad corpotativa.
                        </li>
                        <li>
                          Es su derecho no ser objeto de ning&uacute;n tipo de
                          discriminaci&oacute;n racial, sexual, religiosa,
                          pol&iacute;tica, deportiva, de nacionalidad o por
                          incapacidad f&iacute;sica.
                        </li>
                        <li>
                          Disfrutar de una remuneraci&oacute;n justa, de acuerdo
                          a las funciones que realiza y acorde con la
                          pol&iacute;tica de sueldos establecida por la
                          compa&ntilde;&iacute;a. Disfrutar&nbsp; as&iacute;
                          mismo de los beneficios marginales, que la empresa
                          haya decidido otorgarle.
                        </li>
                        <li>
                          Disfrute del sueldo correspondiente al per&iacute;odo
                          de sus vacaciones, seg&uacute;n lo establece el
                          C&oacute;digo Laboral.
                        </li>
                        <li>
                          Derecho a que la instituci&oacute;n vele por su
                          seguridad f&iacute;sica mientras laboren para esta,
                          garantizando la utilizaci&oacute;n de un
                          botiqu&iacute;n y extintores en las oficinas, para
                          cualquier emergencia.
                        </li>
                        <li>
                          Disfrutar de los d&iacute;as libres que establece la
                          ley, y que previamente dada la naturaleza de la
                          empresa, acuerden con sus supervisores
                        </li>
                        <li>
                          Estar amparado por el plan de seguro m&eacute;dico en
                          la ARS de su elecci&oacute;n, garantiz&aacute;ndole su
                          salud f&iacute;sica y estabilidad emocional.
                        </li>
                        <li>
                          Discutir las normas, reglas y pol&iacute;ticas con las
                          que no concuerde y es su derecho el ser escuchado y
                          que se valore su opini&oacute;n.
                        </li>
                        <li>
                          Obtener todo tipo de capacitaci&oacute;n,
                          adiestramiento o entrenamiento que la empresa pueda
                          otorgarle, seg&uacute;n pol&iacute;tica establecida.
                        </li>
                        <li>
                          Al cuidado de la integridad y respeto de los empleados
                          que prestan servicio a la instituci&oacute;n, cuidando
                          las escenas, intenciones, palabras, o actitudes que
                          puedan ser interpretadas como acoso sexual.
                        </li>
                        <li>
                          Derecho a participar en las actividades de la Empresa
                          a las cuales sea convocado.
                        </li>
                        <li>
                          Quejarse ante la Gerencia de Capital Humanos y/o
                          superior inmediato por cualquier causa que lo
                          justificare y ser escuchado.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="21">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 14. Obligaciones del Empleado
                      </span>
                    </template>
                    <div>
                      <ul>
                        <li>
                          Someterse a reconocimiento m&eacute;dico a
                          petici&oacute;n del empleador, para comprobar que no
                          padece ninguna incapacidad o enfermedad contagiosa
                          &nbsp;que &nbsp;lo imposibilite para realizar su Dicho
                          examen estar&aacute; a cargo del empleador.
                        </li>
                        <li>
                          Asistir con puntualidad al lugar en que deba
                          presentarse para prestar sus servicios y
                          desempe&ntilde;arlos en la forma
                        </li>
                        <li>
                          Observar rigurosamente las medidas preventivas o
                          higi&eacute;nicas exigidas por la ley, las dictadas
                          por las autoridades competentes y las que indique el
                          empleador, para seguridad y protecci&oacute;n personal
                          de ellos o de sus compa&ntilde;eros de labores o de
                          los lugares donde
                        </li>
                        <li>
                          Comunicar al empleador o sus representantes las
                          observaciones que hagan para evitar cualquier
                          da&ntilde;o que puedan sufrir los trabajadores o el
                        </li>
                        <li>
                          Prestar los servicios necesarios en caso de siniestro
                          o riesgo inminente en que la persona o los bienes del
                          empleador o de alg&uacute;n trabajador est&eacute;n en
                          peligro, sin que por ello tengan derecho a
                          remuneraci&oacute;n
                        </li>
                        <li>
                          Observar buena conducta y una estricta disciplina
                          durante las horas de trabajo&nbsp;
                        </li>
                      </ul>
                      <ul>
                        <li>
                          Conservar en buen estado los instrumentos y
                          &uacute;tiles que se les faciliten para el trabajo,
                          sin que sean responsables de su deterioro normal ni
                          del que se ocasione por caso fortuito, fuerza mayor,
                          mala calidad o defectuosa construcci&oacute;n.
                        </li>
                        <li>
                          Guardar rigurosamente los secretos t&eacute;cnicos,
                          comerciales o de fabricaci&oacute;n de los productos a
                          cuya elaboraci&oacute;n concurran directa o
                          indirectamente, o de&nbsp; los cuales tengan
                          conocimiento por raz&oacute;n del trabajo que
                          ejecuten, as&iacute; como de los asuntos
                          administrativos reservados cuya divulgaci&oacute;n
                          pueda causar perjuicio al empleador, tanto mientras
                          dure el contrato de trabajo como despu&eacute;s de su
                          terminaci&oacute;n.
                        </li>
                        <li>
                          Evitar desperdicios innecesarios en la
                          manipulaci&oacute;n de los materiales y devolver al
                          empleador los que no hayan
                        </li>
                        <li>
                          Reportar cualquier incidente, da&ntilde;o, desperfecto
                          o eventualidad que impacte los equipos y herramientas
                          inform&aacute;ticas cuyo desempe&ntilde;o permita en
                          el incumplimiento de sus tareas o
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="22">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 15. Ambiente de Oficina
                      </span>
                    </template>
                    <div>
                      <ul>
                        <li>
                          Presentarse al trabajo o trabajar en estado de
                          embriaguez o en cualquier otra condici&oacute;n
                          an&aacute;loga.
                        </li>
                        <li>
                          Portar armas de cualquier clase durante las horas de
                          labor, salvo las excepciones que para ciertos
                          trabajadores establezca la ley
                        </li>
                        <li>
                          Hacer colectas en el lugar en que presentan servicios,
                          durante las horas de &eacute;ste.
                        </li>
                        <li>
                          Usar los &uacute;tiles y herramientas suministradas
                          por el empleador en el trabajo distinto de aquel al
                          que est&eacute;n destinados, o usar los &uacute;tiles
                          y herramientas del empleador sin su
                          autorizaci&oacute;n.
                        </li>
                        <li>
                          Extraer de la f&aacute;brica, taller o establecimiento
                          &uacute;tiles del trabajo, materia prima o elaborada,
                          sin permiso del empleador
                        </li>
                        <li>
                          Hacer durante el trabajo cualquier tipo de propaganda
                          religiosa o pol&iacute;tica.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="23">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 16. Obligaciones del empleador
                      </span>
                    </template>
                    <div>
                      <p></p>
                      <ul>
                        <li>
                          Proporcionar gratuitamente a los trabajadores los
                          medicamentos preventivos que indiquen las autoridades
                          sanitarias en virtud de la ley, en caso de
                          enfermedades epid&eacute;micas.
                        </li>
                        <li>
                          Mantener las f&aacute;bricas, talleres, oficinas y
                          dem&aacute;s lugares en que deben ejecutarselos
                          trabajos en las condiciones exigidas por las
                          disposiciones sanitarias.
                        </li>
                        <li>
                          Observar las medidas adecuadas y las que fijen las
                          leyes para prevenir accidentes en el uso de
                          maquinarias, instrumentos y material de trabajo.
                        </li>
                        <li>
                          Instalar para el servicio de los obreros, por lo
                          menos, un botiqu&iacute;n de primeros auxilios.
                        </li>
                        <li>
                          Proveer oportunamente a los trabajadores de los
                          materiales que hayan de usar, y, cuando no se hayan
                          comprometidos a trabajar con herramientas propias, de
                          los &uacute;tiles e instrumentos necesarios para la
                          ejecuci&oacute;n del trabajo convenido, sin poder
                          exigirles alquiler por ese concepto.
                        </li>
                        <li>
                          Mantener local seguro para el dep&oacute;sito de los
                          instrumentos y &uacute;tiles del trabajador, cuando
                          &eacute;ste utilice herramientas propias que deban
                          permanecer en el lugar donde se presten los servicios.
                        </li>
                        <li>
                          Pagar al trabajador el salario correspondiente al
                          tiempo que &eacute;ste pierda cuando se vea
                          imposibilitado de trabajar por culpa del empleador.
                        </li>
                        <li>
                          Guardar a los trabajadores la debida
                          consideraci&oacute;n absteni&eacute;ndose de&nbsp;
                          maltrato de palabra o de obra.
                        </li>
                        <li>
                          Proporcionar capacitaci&oacute;n, adiestramiento,
                          actualizaci&oacute;n y perfeccionamiento a sus
                          trabajadores.
                        </li>
                        <li>
                          Cumplir las dem&aacute;s obligaciones que le impone
                          este C&oacute;digo y las que se deriven de las leyes
                          de los contratos de trabajo, de los convenios
                          colectivos y de los reglamentos.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="24">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 17. Prohibiciones los empleadores
                      </span>
                    </template>
                    <div>
                      <ul>
                        <li>
                          Exigir o aceptar dinero de los trabajadores como
                          gratificaci&oacute;n para que se les admita en el
                          trabajo o por cualquier otro motivo relativo a las
                          condiciones de &eacute;ste.
                        </li>
                        <li>
                          Obligar a los trabajadores a que compren sus
                          art&iacute;culos de consumo en tienda o lugar
                          determinado.
                        </li>
                        <li>
                          Hacer colectas y suscripciones en los centros de
                          trabajo.
                        </li>
                        <li>
                          Influir para restringir el derecho de los trabajadores
                          a ingresar o no en un sindicato o a retirarse de
                          aqu&eacute;l a que pertenecen o a permanecer en
                          &eacute;l.
                        </li>
                        <li>
                          Ejercer presi&oacute;n en los trabajadores para que
                          voten por determinada candidatura en la
                          elecci&oacute;n de los funcionarios o representantes
                          de un sindicato.
                        </li>
                        <li>
                          Influir en las actuaciones pol&iacute;ticas o en las
                          creencias religiosas de los trabajadores;
                        </li>
                        <li>
                          Apropiarse o retener, por su sola voluntad, las
                          herramientas u objetos del trabajador, a t&iacute;tulo
                          de indemnizaci&oacute;n, garant&iacute;a o
                          compensaci&oacute;n.
                        </li>
                        <li>
                          Presentarse en la f&aacute;brica, taller o
                          establecimiento en estado de embriaguez o en cualquier
                          otra condici&oacute;n an&aacute;loga.
                        </li>
                        <li>
                          Ejercer acciones contra el trabajador que puedan
                          considerarse de acoso sexual, o apoyar o no intervenir
                          en caso de que lo realicen sus representantes.
                        </li>
                        <li>
                          Ejecutar cualquier acto que restrinja los derechos que
                          el trabajador tiene conforme a la ley.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="25">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 18. Días y Formas de pago</span
                      >
                    </template>
                    <div>
                      <p>
                        Se ha establecido como fecha para cumplir con el
                        compromiso de pago de sueldo al personal laboral fijo,
                        los d&iacute;as 15 y 30 de cada mes, con el modelo
                        de&nbsp; n&oacute;mina electr&oacute;nica, pudiendo
                        incluso ser efectuado a m&aacute;s tardar dentro de la
                        &nbsp;hora subsiguiente a la terminaci&oacute;n de la
                        jornada del d&iacute;a en que corresponda hacer dicho
                        pago. Las comisiones de ventas para cualquier nivel
                        jer&aacute;rquico que corresponda, se pagar&aacute;n los
                        d&iacute;as 30 de cada mes, siempre que la factura del
                        cliente haya sido saldada. En casos de enfermedad o
                        ausencia debidamente justificada, el pago podr&aacute;
                        ser hecho a un representante del trabajador debidamente
                        autorizado.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Para todo lo relativo
                        a la ejecuci&oacute;n de n&oacute;minas ver el
                        procedimiento de compensaci&oacute;n y beneficios
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Las diferentes
                        deducciones aplicables al salario, se aplicar&aacute;n
                        50% los d&iacute;as 15 y 50% los d&iacute;as 30 de cada
                        mes; Para edificar al empleado sobre estos descuentos,
                        se les entregar&aacute; un volante de pago de
                        n&oacute;mina de la quincena, a m&aacute;s tardar tres
                        d&iacute;as laborables despu&eacute;s de aplicado el
                        pago oficial.
                      </p>
                      <p>
                        El Gerente de Capital Humano o el encargado de elaborar
                        la n&oacute;mina enviar&aacute; desde el sistema de
                        n&oacute;mina los volantes v&iacute;a correo
                        electr&oacute;nico, con el fin de que sean recibidos por
                        los colaboradores de las &aacute;reas, confirmando estos
                        a la vez la recepci&oacute;n del mismo a trav&eacute;s
                        del correo.
                      </p>
                      <p></p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="26">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 19. Evaluación del Desempeño:</span
                      >
                    </template>
                    <div>
                      <p>
                        En <strong>TENNOS&nbsp;BUSINESS,</strong> se ha
                        establecido una medici&oacute;n del desempe&ntilde;o, de
                        todos y cada uno de los empleados; esto para poder
                        aplicar medidas equitativas en la asignaci&oacute;n de
                        sueldos, beneficios, premios, formaci&oacute;n o medidas
                        correctivas, etc. Tomando en consideraci&oacute;n el
                        comportamiento, desempe&ntilde;o y rendimiento de cada
                        empleado, esto involucra el cumplimiento de las&nbsp;
                        metas&nbsp; y objetivos establecidos por
                        per&iacute;odos. De esta forma, se efectuar&aacute; una
                        justa apreciaci&oacute;n de los resultados y del valor
                        del esfuerzo y empe&ntilde;o realizado por cada empleado
                        en la funci&oacute;n que desempe&ntilde;e, tanto como en
                        la rapidez de solucionar cualquier problema o pedido que
                        se le haga.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="27">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 20. Festejos Oficiales
                      </span>
                    </template>
                    <div>
                      <p>
                        <strong>TENNOS&nbsp;BUSINESS,</strong> establece de
                        forma institucional la celebraci&oacute;n de:
                      </p>
                      <ul>
                        <li>
                          Fiesta de Navidad para Empleados, igualados y
                          relacionados que se celebrar&aacute; de la forma,
                          lugar y fecha acordada, seg&uacute;n las posibilidades
                          de la organizaci&oacute;n.
                        </li>
                        <li>Actividad del D&iacute;a del Trabajador.</li>
                        <li>Cumplimiento de Objetivos Trimestrales.</li>
                        <li>
                          Celebraci&oacute;n de Cumplea&ntilde;os del Personal:
                          Celebraci&oacute;n con el personal de las fechas del
                          natalicio de cada uno de ellos, mediante
                          publicaci&oacute;n de los cumplea&ntilde;os en el
                          mural Oficialmente&nbsp; se&nbsp; celebran todos los
                          cumplea&ntilde;os del mes al final de la tarde del
                          &uacute;ltimo viernes, del mes correspondiente.
                        </li>
                        <li>
                          Aniversario de la Empresa, 01 de agosto:
                          Celebraci&oacute;n que se aprovecha para dar a conocer
                          los avances, pol&iacute;ticas y procesos en los que la
                          empresa va incurriendo.
                        </li>
                        <li>
                          Se consideran por igual en esta categor&iacute;a los
                          diversos eventos tecnol&oacute;gicos y profesionales
                          preparados por la empresa y/o en los cuales
                          participemos, para los cuales se dispone del personal
                          y la log&iacute;stica necesaria, tales como ferias,
                          lanzamientos, seminarios y otros.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="28">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 21. Jornada de Trabajo</span
                      >
                    </template>
                    <div>
                      <p>
                        <strong>TENNOS&nbsp;BUSINESS,</strong> se acogen a lo
                        establecido en el art&iacute;culo 147 del C&oacute;digo
                        de Trabajo, el cual define a la jornada de trabajo como
                        todo el tiempo que el trabajador no puede utilizar
                        libremente por estar a la disposici&oacute;n exclusiva
                        de su patrono. La duraci&oacute;n normal de la jornada
                        de trabajo es la determinada en el contrato. No
                        podr&aacute; exceder de ocho horas por d&iacute;a ni de
                        cuarenta y cuatro horas por semana. La jornada semanal
                        de trabajo terminar&aacute; a las doce horas meridiano
                        del d&iacute;a s&aacute;bado. Dada la naturaleza de
                        servicios y proyectos de la empresa, como las&nbsp;
                        demandas regulares de trabajo que se originan.
                        As&iacute; como tambi&eacute;n la complejidad de algunas
                        &aacute;reas y lo sensible de algunas funciones,
                        &eacute;sta jornada puede extenderse un poco m&aacute;s
                        con la anuencia y aceptaci&oacute;n del trabajador,
                        tratando de que no excedan de las 44 horas semanales.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="29">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 22. Horario de Trabajo
                      </span>
                    </template>

                    <div>
                      <p>
                        El horario de trabajo, tomando en cuenta las leyes
                        laborales, est&aacute; establecida en 44 horas
                        semanales, iniciando los lunes a viernes 8:00 a.m. hasta
                        las 5:00 p.m y los s&aacute;bados de 8.00 a.m a 12.00
                        p.m, a excepci&oacute;n de:
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Horario De Trabajo De
                        Personal de Apoyo y Servicios
                      </p>
                      <ul>
                        <li>
                          Jornada de 44 horas semanales a partir de las 7:00 M.
                        </li>
                        <li>
                          Con una (1) hora para el almuerzo: Desde la 12:00 m a
                          1:00 pm, o bien de 1:00 pm a 2:00 m.
                        </li>
                      </ul>
                      <p>
                        Para todos los casos, la hora de almuerzo se
                        deber&aacute; aplicar por Direcci&oacute;n, Gerencia y/o
                        Departamentos en forma rotativa, de forma que nunca
                        ning&uacute;n &aacute;rea de la empresa se encuentre sin
                        personal.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3: </strong>Horario De Trabajo
                        Sabatino
                      </p>
                      <p>
                        Si las &aacute;reas est&aacute;n al d&iacute;a con sus
                        distintos compromisos, tareas y/o asignaciones pueden
                        tomarse la ma&ntilde;ana del s&aacute;bado como
                        descanso, a conciencia de que es parte de la jornada y
                        deben asistir si se le convoca.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 4: </strong>Las demandas de
                        horario del personal ser&aacute;n tratadas de forma
                        diferente, y podr&iacute;an diferir en relaci&oacute;n
                        al proyecto y tipo de trabajo que se est&eacute;
                        realizando. Por ello, se establece la posibilidad de
                        realizar trabajos m&aacute;s all&aacute; del horario
                        regular, de acuerdo a los requerimientos de sus
                        responsabilidades.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="30">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 23. Ingesta de Alimentos del Personal
                      </span>
                    </template>
                    <div>
                      <p>
                        <strong>TENNOS&nbsp;BUSINESS,</strong> ha dispuesto un
                        ambiente en la cocina para facilitar la ingesta de
                        alimento por parte del personal, aun as&iacute; la
                        decisi&oacute;n de comer dentro del comedor o fuera de
                        las instalaciones, es propia de cada empleado, siempre
                        que se realice en el tiempo reglamentado para ello. Por
                        medio de esta pol&iacute;tica, y espec&iacute;ficamente
                        para el tema &ldquo;desayuno&rdquo; queda limitado una
                        vez se inicie la jornada de trabajo, (8:00 a.m.),
                        as&iacute; como que el personal salga fuera de las
                        instalaciones a comprar este alimento, restando un
                        tiempo valioso al inicio de las labores, caso que se
                        puede calificar como &ldquo;abandono del puesto&rdquo;.
                        <strong
                          >Todo desayuno debe ser dispuesto antes del inicio de
                          la Jornada de Trabajo, seg&uacute;n los h&aacute;bitos
                          personales de cada uno.</strong
                        >

                        Igualmente, queda prohibida la ingesta de alimentos en
                        los escritorios y &aacute;reas de trabajo, de toda la
                        instituci&oacute;n. As&iacute; mismo para la hora de
                        almuerzo, la cual est&aacute; establecida hasta las 2:00
                        p.m., luego de este tiempo es deber del trabajador estar
                        en su estaci&oacute;n de trabajo, salvo previo aviso y
                        permiso de su supervisor inmediato.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="31">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 24. Licencias Remuneradas
                      </span>
                    </template>
                    <div>
                      <p>
                        En atenci&oacute;n a los requerimientos del
                        Art&iacute;culo 54 del C&oacute;digo de Trabajo, se
                        otorgan las licencias remuneradas, siempre y cuando
                        est&eacute;n amparadas por los requisitos que para cada
                        caso se apliquen.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo</strong>
                        <strong>1: </strong>Licencia por matrimonio
                      </p>
                      <p>
                        La Ley concede al empleado cinco (5) d&iacute;as con
                        disfrute de sueldo, de licencia por matrimonio, a partir
                        de la fecha del mismo.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo</strong>
                        <strong>2:</strong> Licencia por Fallecimiento Familiar:
                      </p>
                      <p>
                        La ley establece tres (3) d&iacute;as de licencia al
                        empleado con disfrute de&nbsp; sueldo,
                        refiri&eacute;ndose al fallecimiento de parientes
                        directos. Siempre que hayan sido reconocidos como
                        familiares de ese empleado, por esta empresa.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo</strong>
                        <strong>3:</strong> Licencia por Enfermedad
                      </p>
                      <p>
                        Cualquier ausencia por problemas de salud, debe ser
                        avalada mediante Certificado M&eacute;dico, firmada por
                        profesional del &aacute;rea competente, a las 24 Horas
                        de que se hubiese producido la enfermedad, accidente, o
                        padecimiento.&nbsp;
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 4: </strong>Licencia por
                        Alumbramiento
                      </p>
                      <ul>
                        <li>
                          Licencia para la Empleada: Para la mujer en estado de
                          embarazo y acogi&eacute;ndonos al Art&iacute;culo 237
                          sobre descanso pre-post Natal, nos acogemos al
                          descanso forzoso que establece la ley, durante las
                          siete (7) semanas que preceden a la posible fecha de
                          parto y las siete (7) semanas posteriores a esa fecha.
                          Dicho reposo, no ser&aacute; de menos de 14 semanas en
                          conjunto, durante este per&iacute;odo, la empleada
                          disfrutar&aacute; de su salario y conservar&aacute;
                          todos los derechos que de &eacute;ste se derivan.
                        </li>
                        <li>
                          Licencia para el Trabajador: En caso de alumbramiento
                          de la Se&ntilde;ora, o Esposa del trabajador, la Ley
                          le otorga dos (2) d&iacute;as de licencia al
                          compa&ntilde;ero, el cual debe notificar a la Gerente
                          de Capital Humano, de
                          <strong>TENNOS&nbsp;BUSINESS,</strong> tan pronto
                          ocurra el nacimiento de su v&aacute;stago.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="32">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 25. Materiales de Oficina</span
                      >
                    </template>
                    <div>
                      <p>
                        La adquisici&oacute;n de estos art&iacute;culos se
                        realizar&aacute; previa requisici&oacute;n autorizada
                        por el Director o Encargado que posea la necesidad, y
                        seg&uacute;n los requerimientos de los trabajos. El
                        pedido de compras de suministro se realizar&aacute; los
                        d&iacute;as mi&eacute;rcoles de cada semana para ser
                        entregado al siguiente d&iacute;a laboral. Es
                        responsabilidad de todo el personal, velar por la
                        utilizaci&oacute;n con medida de los materiales de
                        oficina, evitando el abuso, cuidando que se usen en la
                        proporci&oacute;n, y en la forma adecuada y para los
                        fines que se adquieren, y que estos sean eminentemente
                        laborales. Siendo el desperdicio y abuso causal de
                        despido del trabajador.&nbsp;
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>La compra de material
                        impreso se canaliza seg&uacute;n procedimiento
                        establecido, a trav&eacute;s del &Aacute;rea de
                        Adquisiciones. En caso de que se trate de formularios
                        nuevos corresponde al interesado motivar y justificar la
                        emisi&oacute;n de la Requisici&oacute;n de compra,
                        ajustando el modelo o dise&ntilde;o al estilo e imagen
                        de la empresa.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>La entrada de
                        art&iacute;culos personales a la empresa debe ser
                        notificada a la recepci&oacute;n antes de acceder a las
                        instalaciones para el debido registro de entrada y
                        salida de activos.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="33">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 26. Naturaleza de la Institución y de los
                        Trabajos.
                      </span>
                    </template>
                    <div>
                      <p>
                        Esta empresa se caracteriza por brindar servicios de
                        soluciones&nbsp; tecnol&oacute;gicas en las &aacute;reas
                        de pagos seguros; abarcando el dise&ntilde;o,
                        implementaci&oacute;n, puesta en marcha y mantenimiento
                        de las instalaciones de sistemas y productos
                        tecnol&oacute;gicos. Se trabaja con un alto nivel de
                        precisi&oacute;n y calidad, con respeto e integridad a
                        los clientes, relacionados, y todos nuestros
                        compa&ntilde;eros, aplicando excelentes relaciones
                        humanas y buen trato, cuidando del medio ambiente y las
                        reglas de comportamiento social y protocolo que
                        caracterizan nuestra cultura laboral. Proporcionamos
                        seguridad, tranquilidad y confianza en todos nuestros
                        trabajos, lo que nos permite un alto nivel de desarrollo
                        en el mercado local, por lo que es pol&iacute;tica de la
                        empresa, velar por el mantenimiento de ese nivel de
                        ejecuci&oacute;n para obtener el m&aacute;s alto nivel
                        de satisfacci&oacute;n de nuestros clientes. Los
                        servicios abarcan a todo el pa&iacute;s, y nuestros
                        proveedores son internacionales. Nuestro objetivo es
                        extender los servicios por igual a nivel internacional.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="34">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 27. Normas Disciplinarias
                      </span>
                    </template>
                    <div>
                      <p>
                        Todos los empleados est&aacute;n en la obligaci&oacute;n
                        de cumplir con las normas y pol&iacute;ticas
                        establecidas por <strong>TENNOS&nbsp;BUSINESS,</strong>,
                        en caso contrario, las sanciones por faltas cometidas
                        ser&aacute;n solicitadas e iniciadas por el superior
                        inmediato, quien podr&iacute;a a su vez clasificar
                        est&aacute;s de acuerdo al alcance de las conductas o
                        equivocaciones en: &ldquo;Leves&rdquo;y
                        &ldquo;Severas&rdquo;.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>El superior
                        podr&aacute; solicitar la aplicaci&oacute;n de las
                        correcciones disciplinarias que establece el
                        art&iacute;culo 42 del C&oacute;digo Laboral,
                        (Amonestaciones y Anotaci&oacute;n de faltas en el
                        Expediente del Empleado). La falta cometida debe ser
                        juzgada en apego a las leyes, y notificadas siempre al
                        empleado/a y al Ministerio de Trabajo.&nbsp;
                      </p>
                      <p>
                        Las faltas cometidas seran atendidas de la siguiente
                        manera:
                      </p>
                      <p>
                        <strong>1&ordm;. </strong>Amonestaci&oacute;n escrita
                        con reposo en el expediente del empleado.
                      </p>

                      <p>
                        <strong>2&ordm;. </strong>Amonestaci&oacute;n escrita
                        con copia al Ministerio de trabajo.
                      </p>
                      <p>
                        <strong>3&ordm;. </strong>Despido del trabajador,
                        justificado y seg&uacute;n corresponda, de acuerdo al
                        art&iacute;culo 88 del CT.
                      </p>
                      <p>
                        Aquellas faltas consideradas
                        <strong>Leves </strong>ameritaran una
                        amonestaci&oacute;n escrita con reposo en el expediente
                        del trabajador y aquellas faltas consideradas
                        <strong>severas </strong>ameritaran una
                        amonestaci&oacute;n escrita con copia al ministerio de
                        trabajo o hasta el despido del trabajador.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="35">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 28. Clasificación de las Faltas</span
                      >
                    </template>
                    <div>
                      <p>
                        Para la aplicaci&oacute;n del presente documento, las
                        faltas han sido clasificadas en leves, graves y severas.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1. </strong>Son consideradas
                        faltas <strong>leves </strong>aquellas que no
                        constituyen peligro para la correcta operaci&oacute;n de
                        la empresa. Generalmente se refieren a problemas que
                        pueden ser corregidos entre el Supervisor y el
                        colaborador. Sin embargo, si no se le da el seguimiento
                        oportuno pueden convertirse en faltas graves.
                      </p>
                      <p>Ejemplos:</p>
                      <ol>
                        <li>
                          Cuando se incurra hasta en dos tardanzas en un mes sin
                          causa justificada. Las tardanzas se consideran
                          despu&eacute;s de la hora de entrada que le
                          corresponda al&nbsp;colaborador.
                        </li>
                        <li>
                          No usar el carn&eacute; de identificaci&oacute;n al
                          ingresar a las oficinas y durante las
                          horas&nbsp;laborables.
                        </li>
                        <li>
                          Descuido en conservaci&oacute;n de los equipos,
                          materiales o documentos de trabajo, sin
                          perjuicios&nbsp;mayores.
                        </li>
                        <li>
                          No observar las normas de estacionamiento y parqueo
                          establecidas por la Empresa.
                        </li>
                        <li>
                          Fumar dentro de las &aacute;reas comunes de
                          la&nbsp;empresa.
                        </li>
                        <li>
                          Ingerir alimentos dentro de las oficinas en horario de
                          trabajo.
                        </li>
                        <li>
                          Uso indebido de las herramientas de trabajo tales como
                          computadora, fotocopiadora, entre otras, para
                          actividades no laborales (ejemplo: juegos, asuntos
                          personales).
                        </li>
                        <li>
                          Contribuir a crear condiciones de insalubridad por
                          falta de&nbsp;limpieza&nbsp;.
                        </li>
                      </ol>
                      <ol start="9">
                        <li>
                          Falta ocasional en el uso del uniforme los d&iacute;as
                          establecidos.
                        </li>
                        <li>
                          No acatar las &oacute;rdenes que les impartan sus
                          superiores inmediatos y efectuar las tareas
                          adicionales que les asignen, siempre que las mismas no
                          afecten la operatividad de la empresa.
                        </li>
                      </ol>
                      <p>
                        <strong>P&aacute;rrafo 2. </strong>Son consideradas
                        faltas <strong>severas </strong>aquellos actos que
                        da&ntilde;an la imagen de Empresa, causan problemas y
                        dificultades al buen funcionamiento de la misma, y las
                        acciones no tolerables especificadas en el C&oacute;digo
                        de Trabajo art 88.
                      </p>
                      <p>Ejemplos:</p>
                      <ol>
                        <li>
                          Violentar procedimientos o documentaci&oacute;n de la
                          Empresa sin autorizaci&oacute;n, aun cuando dicha
                          violaci&oacute;n no conlleve perjuicios a estas.
                        </li>
                        <li>
                          Hacer uso de las facultades de su puesto para otorgar
                          concesiones fuera de lo establecido por la empresa, en
                          beneficio propio, de sus parientes o de relacionados.
                        </li>
                        <li>
                          Toda aplicaci&oacute;n de pol&iacute;tica o beneficio
                          que un colaborador tiene la facultad de autorizar,
                          deber&aacute; ser aprobada por su supervisor cuando el
                          beneficiario sea el mismo colaborador, parientes o
                          relacionados.
                        </li>
                        <li>
                          Ausentarse o no asistir a los eventos de
                          capacitaci&oacute;n y entrenamiento convocados por la
                          empresa, sin causa justificada y sin la previa
                          autorizaci&oacute;n del supervisor o Capital
                        </li>
                        <li>
                          Incurrir en tres tardanzas en un Se considera tardanza
                          despu&eacute;s de la hora de entrada que le
                          corresponda al colaborador.
                        </li>
                        <li>
                          Realizar gastos no justificados en el desempe&ntilde;o
                          normal del negocio, sin la previa autorizaci&oacute;n
                          del supervisor.
                        </li>
                        <li>
                          Acceder o usar, sin autorizaci&oacute;n para ello, a
                          canales electr&oacute;nicos, datos sensibles, equipos
                          computarizados, informes y listados de clientes,
                          haciendo uso indebido de identificaci&oacute;n de
                          usuario (user-id) y password, obtenidos maliciosamente
                          o con enga&ntilde;o, o bien empleando mecanismos de
                          intromisi&oacute;n no establecidos para los usuarios.
                        </li>
                        <li>
                          Exponer a riesgos innecesarios medios
                          electr&oacute;nicos, tales como CD, DVD, USB, discos
                          port&aacute;tiles o equivalentes.
                        </li>
                      </ol>
                      <p></p>
                      <p>&nbsp;</p>
                      <ol start="9">
                        <li>
                          Almacenar informaci&oacute;n necesaria para la
                          Empresa, en medios que carecen de seguridad.
                        </li>
                        <li>
                          Dejar abiertas computadores de uso personal con
                          aplicaciones. Utilizar el correo electr&oacute;nico en
                          forma indebida.
                        </li>
                        <li>
                          Contaminar equipos computarizados de la Empresa por
                          utilizar archivos&nbsp; con virus y, ocultar
                          informaci&oacute;n o no informar oportunamente a su
                          superior jer&aacute;rquico, de situaciones de riesgo
                          para la informaci&oacute;n o sistemas&nbsp; de&nbsp;
                          la Empresa.
                        </li>
                        <li>
                          Instalar en las computadoras personales, programas
                          ilegales, para funciones de la Empresa o para
                          terceros, incluidos los juegos para computadoras.
                        </li>
                        <li>
                          Utilizar el correo electr&oacute;nico para el
                          env&iacute;o masivo de mails que bloqueen el servicio.
                        </li>
                        <li>
                          Enviar informaci&oacute;n ajena al inter&eacute;s de
                          la Empresa, tales como cadenas, im&aacute;genes,
                          m&uacute;sica, videos, juegos o cualquier tipo de
                          software.
                        </li>
                        <li>
                          Enviar por correo electr&oacute;nico u otro medio,
                          archivos con fotos videos pornogr&aacute;ficos a
                          usuarios o terceras.
                        </li>
                        <li>
                          Asimismo, en la recepci&oacute;n de correos
                          electr&oacute;nicos, deber&aacute; cuidarse la
                          apertura de emails de direcciones desconocidas, los
                          que deber&aacute;n borrarse antes de ser En
                          relaci&oacute;n con los archivos adjuntos,
                          &eacute;stos deber&aacute;n ser escaneados para evitar
                          posibles virus y c&oacute;digos maliciosos.
                        </li>
                        <li>
                          No asumir la responsabilidad de cada usuario, de
                          destruir los medios de almacenamiento,
                          electr&oacute;nicos o en papel, antes de eliminarlos o
                          botarlos a la basura; tales como CD, DVDS, discos
                          duros, entre En el caso de la informaci&oacute;n
                          contenida en papel, debe destruirse antes de enviarlo
                          al zafac&oacute;n.
                        </li>
                        <li>
                          No asumir la responsabilidad de cada usuario, de no
                          bajar desde la&nbsp; web (Internet) cualquier material
                          inapropiado para los fines del negocio y de&nbsp; la
                          funci&oacute;n para la que fue contratado.
                        </li>
                        <li>
                          No se permite bajar archivos de Internet, referidos a
                          m&uacute;sica, videos, etc. Toda informaci&oacute;n
                          obtenida utilizando Internet como fuente,
                          deber&aacute; ser verificada antes de ser usada para
                          fines del negocio, salvo aquellas que sean&nbsp;
                          necesarias para sus funciones.
                        </li>
                      </ol>
                      <ol start="20">
                        <li>
                          Obstruir las investigaciones que se desarrollen para
                          determinar delitos o fraudes que afecten al
                          &aacute;mbito de Seguridad de la Informaci&oacute;n o
                          Continuidad&nbsp; del Negocio, impidiendo el acceso a
                          la informaci&oacute;n solicitada, no
                          proporcion&aacute;ndola en los plazos requeridos o
                          bien, proporcionando informaci&oacute;n alterada.
                        </li>
                        <li>
                          Hacer colectas en el lugar en que prestan servicios,
                          durante las horas de &eacute;ste.
                        </li>
                        <li>
                          La reincidencia por m&aacute;s de tres veces en los
                          casos que hayan merecido llamado de atenci&oacute;n
                          verbal dentro del mismo periodo mensual. La
                          reincidencia que se refiere el presente literal
                          ser&aacute; causal para una amonestaci&oacute;n
                          escrita.
                        </li>
                        <li>Una ausencia en el mes, sin causa justificada.</li>
                        <li>
                          Incurrir en falta de probidad o de honradez, actos de
                          violencia, injuria o proferir palabras que atenten
                          contra la moral y la dignidad de supervisores,
                          compa&ntilde;eros, clientes, familiares del empleador
                          y p&uacute;blico en general.
                        </li>
                        <li>Abandono del trabajo.</li>
                        <li>
                          Dejar de asistir al trabajo por dos d&iacute;as en un
                          mes sin causa justificada.
                        </li>
                        <li>
                          Asistir al trabajo en estado de embriaguez o bajo
                          efectos de estupefacientes.
                        </li>
                        <li>
                          Divulgar informaci&oacute;n confidencial de la Empresa
                          o de sus clientes.
                        </li>
                        <li>Falsificar registros de la Empresa.</li>
                        <li>
                          Modificar, sin la autorizaci&oacute;n correspondiente,
                          los procedimientos establecidos, con perjuicios para
                          la Empresa.
                        </li>
                        <li>
                          Intento de abuso y acoso sexual contra un subordinado
                          y/o compa&ntilde;ero de trabajo.
                        </li>
                        <li>
                          Presentar referencias, certificados personales,
                          licencias m&eacute;dicas y cualquier otro documento
                          falso.
                        </li>
                        <li>
                          Comprobada ineficiencia en el desempe&ntilde;o de las
                          funciones, luego de tener la oportunidad de participar
                          en un plan de mejoramiento.
                        </li>
                      </ol>
                      <p></p>
                      <p>&nbsp;</p>
                      <ol start="34">
                        <li>
                          Recibir de clientes o relacionados, d&aacute;divas o
                          prebendas de cualquier especie, otorgada
                          premeditadamente con el fin de obtener facilidades,
                          concesiones o gestionar una decisi&oacute;n favorable.
                        </li>
                        <li>
                          Incumplimiento con pol&iacute;ticas y procedimientos
                          establecidos que ocasionen p&eacute;rdidas
                          significativas para la Empresa.
                        </li>
                        <li>
                          Actuar negligentemente, provocando la
                          inutilizaci&oacute;n o destrucci&oacute;n de recursos
                          computacionales de la Empresa, tales como datos
                          sensibles, software adquirido o desarrollado por la
                          Empresa, hardware y bloquear el servicio de cualquier
                          plataforma de la Empresa.
                        </li>
                        <li>
                          Modificar, en forma no autorizada, datos, software en
                          producci&oacute;n, hardware y software b&aacute;sicos.
                        </li>
                        <li>
                          Intercambiar recursos de computaci&oacute;n con
                          personas de otros departamentos de la Empresa , tales
                          como software que le han asignado para su
                          funci&oacute;n, datos sensibles que le corresponda
                          manejar, equipos computarizados, user-id o password,
                          tarjetas y claves para el acceso f&iacute;sico y
                          l&oacute;gico.
                        </li>
                        <li>
                          Transmitir o exponer fotos o videos con
                          pornograf&iacute;a, a trabajadores o terceras personas
                          en forma interna o externa a la Empresa.
                        </li>
                        <li>
                          Retrasos, negligencias o descuidos en el cumplimiento
                          de sus funciones.
                        </li>
                        <li>
                          Efectuar copias no autorizadas de softwares adquiridos
                          por la Empresa, as&iacute; como datos de toda
                          &iacute;ndole, ya sea para uso propio de tercero.
                        </li>
                        <li>
                          Salir del lugar de trabajo sin comunicar previamente
                          al supervisor, la causa que justifique dicha salida.
                        </li>
                        <li>
                          Poner en riesgo activos de la Empresa divulgando a
                          terceros, listados o archivos con informaci&oacute;n
                          que pudieran afectar a la organizaci&oacute;n en
                          t&eacute;rminos legales o comerciales.
                        </li>
                        <li>
                          Uso parcial del tiempo del trabajo para otros asuntos
                          (por ejemplo: ventas personales, rifas, extensas
                          conversaciones de asuntos personales, diligencias
                          Personales fuera de la empresa, entre otras).
                        </li>
                      </ol>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="36">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 29. Ambiente de Oficina
                      </span>
                    </template>
                    <div>
                      Como empresas de servicios, ejecutora de actividades y
                      proyectos tecnológicos varios,
                      <strong>TENNOS&nbsp;BUSINESS,</strong>, están orientadas a
                      brindar servicios de calidad, sujetos a normas y
                      estándares de eficiencia y buen servicio, cuyas
                      características pueden apreciarse en el desarrollo de cada
                      una de los compromisos y trabajos asumidos. Es por esta
                      razón que los empleados de
                      <strong>TENNOS&nbsp;BUSINESS,</strong>, deben colaborar en
                      el sostenimiento de la filosofía de nuestra cultura
                      organizacional, manifestado desde el orden y aspecto del
                      local, hasta el logro de la eficacia, eficiencia, rapidez
                      y calidad de nuestros servicios. Es responsabilidad de
                      todos los empleados de
                      <strong>TENNOS&nbsp;BUSINESS,</strong>, velar por mantener
                      un ambiente agradable, de respeto y acorde con nuestra
                      imagen corporativa, durante sus horas de trabajo, y hasta
                      después de la jornada.
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="36">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 29. Pago de Comisiones e Incentivos
                      </span>
                    </template>
                    <div>
                      <p>
                        Todo lo relativo a pago de comisiones e incentivos se
                        refiere al procedimiento de compensaci&oacute;n y
                        beneficios, la Normativa de incentivos del &aacute;rea
                        de Soporte T&eacute;cnico y a la normativa de Comisiones
                        e Incentivos de Ventas. Adem&aacute;s, de incentivos
                        para aumento de facturaci&oacute;n y cobros. Tomando en
                        consideraci&oacute;n los siguientes aspectos:
                      </p>
                      <ul>
                        <li>
                          Las comisiones e incentivos estar&aacute;n siempre
                          vinculadas al cumplimiento de metas u objetivos
                          establecidas para la posici&oacute;n.
                        </li>
                        <li>
                          Todas las metas deben estar escritas, notificadas y
                          socializadas con los responsables, as&iacute; como
                          firmadas y selladas por los empleados y sus
                          superiores.
                        </li>
                        <li>
                          Cada definici&oacute;n de meta u objetivos,
                          deber&aacute; tener claro el per&iacute;odo al cual
                          corresponde y se constituye en un adendum del contrato
                          de trabajo del empleado.
                        </li>
                        <li>
                          Las metas u objetivos son ajustadas de acuerdo al
                          tiempo, condiciones&nbsp; de trabajo y del mercado.
                        </li>
                        <li>
                          Se utilizar&aacute; el cumplimiento de metas u
                          objetivos para los procesos&nbsp; de evaluaci&oacute;n
                          y/o reconocimientos del personal.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="37">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 30. Período de Prueba
                      </span>
                    </template>
                    <div>
                      <p>
                        Hemos establecido un per&iacute;odo de prueba del
                        empleado de nuevo ingreso o nuevo en la posici&oacute;n
                        m&iacute;nimo de tres meses, tal y como establece el
                        C&oacute;digo de Trabajo Dominicano, al final del mismo
                        el trabajador ser&aacute; evaluado y el resultado de esa
                        evaluaci&oacute;n decidir&aacute; su fijaci&oacute;n o
                        permanencia en la empresa.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong
                        >Espec&iacute;ficamente para los puestos en el
                        &aacute;rea de ventas, Ejecutivos de Ventas u otros, se
                        establece un per&iacute;odo probatorio de tres meses, al
                        final del mismo&nbsp; el trabajador ser&aacute; evaluado
                        y el resultado de esa evaluaci&oacute;n decidir&aacute;
                        su fijaci&oacute;n o permanencia en la empresa a partir
                        de los 3 meses, del mismo modo, se le seguir&aacute;
                        dando seguimiento a su desempe&ntilde;o.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Como resultado de la
                        evaluaci&oacute;n de estos tres meses el empleado puede
                        ser retirado, fijado o bien ampli&aacute;rsele, por
                        igual que a los vendedores, su per&iacute;odo
                        probatorio. A partir de su fijaci&oacute;n, el empleado
                        adquiere todos los derechos que establece el
                        C&oacute;digo de Trabajo, adem&aacute;s tiene la
                        opci&oacute;n de optar por otros beneficios que la
                        empresa ofrece, tales como el seguro m&eacute;dico
                        complementario.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="38">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 31. Permisos en Horas Laborables
                      </span>
                    </template>
                    <div>
                      <p>
                        El empleado que necesite, por razones justificadas,
                        solicitar permiso para abandonar la
                        <span>empresa en </span>horas laborables, deber&aacute;
                        llenar el formulario &ldquo;Solicitud de
                        Permisos&rdquo;<em>, </em
                        ><span
                          >el cual deber&aacute; ser autorizado por su Superior
                          Inmediato, quien considerar&aacute; si puede otorgarlo
                          y tomar&aacute; la previsi&oacute;n de sustituirle en
                          caso de que fuera necesario.</span
                        >
                      </p>
                      <p>
                        Este formulario establece las razones de la salida, la
                        fecha y la duraci&oacute;n de la tardanza o ausencia.
                        Cada permiso debe ser solicitado por lo menos con 24
                        horas de anticipaci&oacute;n.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>La
                        autorizaci&oacute;n de los permisos por parte del
                        Supervisor Inmediato queda a criterio del mismo,
                        considerando las tareas pendientes del empleado. A menos
                        que obedezca a razones de fuerza mayor, las cuales deben
                        ser justificadas con las evidencias pertinentes.
                      </p>
                      <p>
                        <strong>Parrafo2: </strong>Todo permiso concedido por el
                        Supervisor Inmediato sin la documentaci&oacute;n que
                        avale el mismo ser&aacute; motivo de amonestaci&oacute;n
                        sin previo llamado de atenci&oacute;n.
                      </p>
                      <p>
                        <strong>Parrafo3: </strong>Los &uacute;nicos permisos
                        remunerados son los se&ntilde;alados en el Art. 54 del
                        CT: 5 d&iacute;as por matrimonio, 3 d&iacute;as por
                        fallecimiento de abuelos, padres, hijos o c&oacute;nyuge
                        y 2 d&iacute;as por alumbramiento de esposa. Fuera de
                        esos casos, los dem&aacute;s permisos no se pagan.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="39">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 32. Plan Seguro Médico (ARS)
                      </span>
                    </template>
                    <div>
                      <p>
                        En cumplimiento de la Ley 187-01 de Seguridad Social,
                        todos los empleados de nuestra empresa disfrutan de los
                        tres planes de seguros establecidos: Seguro de Salud,
                        Plan de Pensiones y Seguro de Riesgos Laborales.
                        <strong>TENNOS&nbsp;BUSINESS,</strong>, ofrece dentro de
                        los &nbsp;beneficios marginales a los empleados, una vez
                        aprobado el per&iacute;odo probatorio establecido, un
                        plan de seguro m&eacute;dico complementario con la ARS
                        que elija la empresa, pudiendo cambiarla en cualquier
                        momento, del cual la empresa aporta el 100% de la prima.
                        Los dependientes directos de los empleados est&aacute;n
                        cubiertos por el Seguro Familiar de Salud de la TSS, en
                        caso de que un empleado desee incluir a cualquier
                        familiar, dentro del plan complementario que ofrece la
                        empresa, &eacute;ste lo podr&aacute; hacer cubriendo los
                        costos que represente, los cuales se les
                        descontar&aacute; v&iacute;a n&oacute;mina.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="40">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 33. Porte de Armas de Fuego y/o Armas Blancas
                      </span>
                    </template>
                    <div>
                      <p>
                        Queda terminantemente prohibido el porte o
                        exhibici&oacute;n de armas de fuego y/o armas blancas
                        dentro de cualquiera de las instalaciones de
                        <strong>TENNOS&nbsp;BUSINESS,</strong>, y en la
                        localidad del cliente o lugar de trabajo, siempre que se
                        represente a una de las empresas. Si alg&uacute;n
                        cliente o visitante posee un arma, deber&aacute;
                        entregarla en la Recepci&oacute;n de
                        <strong>TENNOS&nbsp;BUSINESS,</strong>, donde
                        ser&aacute; guardada hasta su salida de la empresa, no
                        pudi&eacute;ndose entregar a nadie m&aacute;s que no sea
                        el due&ntilde;o o portador de la misma. Y completando el
                        Formulario Resguardo de Armas. Todas las armas que sean
                        entregadas a la Recepcionista, deben ser recibidas y
                        resguardadas en un armario con llave por personal de
                        Seguridad, envueltas en el formulario firmado, y fuera
                        del alcance de cualquier otra persona.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="41">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 34. Vestimenta del Personal:
                      </span>
                    </template>
                    <div>
                      <p>
                        Declaramos que el C&oacute;digo de Vestimenta es:
                        Formal-Casual. El uso de Uniformes queda reglamentado de
                        acuerdo a las posiciones que ocupen los empleados:
                      </p>
                      <ul>
                        <li>
                          El personal Administrativo y del &aacute;rea Comercial
                          de sexo femenino, deber&aacute; usar ropa ejecutiva, a
                          saber: Chaqueta, Blusa, Pantal&oacute;n o Falda, en
                          colores alineados a la imagen de la empresa y
                          manteniendo la prudencia, evitando escotes
                          pronunciados, transparencias y blusas sin&nbsp;mangas.
                        </li>
                        <li>
                          En el caso del personal de oficina de sexo masculino:
                          pantal&oacute;n de vestir, camisa y corbata
                          (opcional).
                        </li>
                        <li>
                          En caso de los Ejecutivos de Ventas se alinean al
                          C&oacute;digo de vestuario ejecutivo de&nbsp;hombres.
                        </li>
                        <li>
                          El personal T&eacute;cnico, de Mantenimiento y
                          Mensajer&iacute;a, trabajar&aacute; identificado por
                          camisas y/o polo, as&iacute; como jeans o
                          pantal&oacute;n casual con el logo de las diferentes
                          empresas, dentro del estilo Pr&aacute;ctico-Casual.
                        </li>
                        <li>
                          El personal t&eacute;cnico de talleres podr&aacute;
                          utilizar adem&aacute;s, batas tipo laboratorio, con el
                          logo de la empresa y&nbsp;asociados.
                        </li>
                        <li>
                          Los empleados cuidar&aacute;n su imagen, al velar por
                          tener el pelo limpio y arreglado de forma tradicional,
                          u&ntilde;as limpias y pintadas con colores tenues, al
                          igual que el maquillaje.
                        </li>
                        <li>
                          El Uniforme se utilizar&aacute; de forma regular de
                          lunes a jueves, los viernes se utilizar&aacute;
                          siempre el su&eacute;ter de la empresa y jeans, para
                          aligerar el C&oacute;digo de vestimenta utilizado,
                          para el resto de la semana, para el personal de
                          servicios generales.
                        </li>
                        <li>
                          El personal Sub-contratado deber&aacute; portar
                          Carnets que &nbsp;los identifique como
                          &ldquo;CONTRATISTAS&rdquo;.
                        </li>
                        <li>
                          En caso de que fuera necesario y dependiendo del tipo
                          de proyecto los contratistas podr&aacute;n utilizar
                          polo de la empresa, con el logo de la empresa y, la
                          leyenda de&nbsp;CONTRATISTAS.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="42">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 35. Préstamos Personales
                      </span>
                    </template>
                    <div>
                      <p>
                        <strong>TENNOS&nbsp;BUSINESS,</strong>, no contempla el
                        otorgamiento de pr&eacute;stamos a empleados. Para
                        solucionar algunas necesidades que pudieran
                        present&aacute;rseles a los colaboradores, la empresa ha
                        firmado un acuerdo con el Banco de Reservas de la
                        Rep&uacute;blica Dominicana y/o cualquier otra
                        instituci&oacute;n financiera, que contempla la
                        posibilidad de acceder a diferentes tipos de
                        pr&eacute;stamos con sus prestaciones en
                        garant&iacute;a. Todo este proceso debidamente
                        autorizado y documentado de acuerdo a las leyes
                        nacionales.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1. </strong>Los empleados
                        podr&aacute;n acceder a este pr&eacute;stamo luego de
                        los 6 meses laborando para la empresa, mediante el uso
                        de los formularios existentes en el &aacute;rea de
                        Capital Humano.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2. </strong>El monto aprobado no
                        podr&aacute; exceder el 70% del c&aacute;lculo de los
                        derechos adquiridos que le corresponder&iacute;an al
                        momento de la solicitud. Comprometi&eacute;ndose con el
                        banco, bajo contrato, a que ellos le debiten de manera
                        autom&aacute;tica el monto de la mensualidad m&aacute;s
                        intereses en la fecha acordada de su cuenta de
                        n&oacute;mina.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3. </strong>En caso de
                        t&eacute;rmino del contrato la empresa saldar&aacute; la
                        deuda pendiente del empleado con la entidad financiera y
                        en los casos en que su liquidaci&oacute;n no fuese
                        suficiente para saldar el pr&eacute;stamo, el trabajador
                        se compromete a responsabilizarse por el pago de la
                        deuda directamente con el banco.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="43">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 36. Programas de Pasantías</span
                      >
                    </template>
                    <div>
                      <p>
                        Por la naturaleza de la empresa queda regulado el
                        permitir que j&oacute;venes t&eacute;cnicos o
                        profesionales, realicen pasant&iacute;as en &aacute;reas
                        relativas a sus estudios, y, de acuerdo a las demandas
                        de la empresa, y las posibilidades de espacio, recursos
                        y trabajo.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Para aplicar por una
                        pasant&iacute;a los j&oacute;venes deber&aacute;n
                        cumplir con el proceso de reclutamiento y
                        selecci&oacute;n regular establecido, inici&aacute;ndose
                        de aprobar, con un salario b&aacute;sico por debajo del
                        sueldo de la posici&oacute;n.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Como empleado pasante
                        de la empresa deber&aacute; cumplir con todas las
                        normativas establecidas por la misma, y por su superior
                        inmediato.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3: </strong>La duraci&oacute;n de
                        cada pasant&iacute;a depender&aacute; del
                        prop&oacute;sito, si sobrepasa de los 90 d&iacute;as,
                        nos acogemos a las medidas legales. Bajo esta premisa,
                        una pasant&iacute;a podr&aacute; durar hasta un
                        a&ntilde;o.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="44">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 37. Propinas y Regalos
                      </span>
                    </template>
                    <div>
                      <p>
                        Queda prohibido para todo el personal la
                        aceptaci&oacute;n directa o indirecta de comisiones,
                        propinas o regalos de clientes finales o intermedios,
                        as&iacute; como de proveedores o suplidores que
                        mantengan relaci&oacute;n o negociaciones con
                        <strong>TENNOS&nbsp;BUSINESS,</strong>, En caso de que
                        alg&uacute;n relacionado decida otorgar este detalle,
                        deber&aacute; solicitar una aprobaci&oacute;n ejecutiva,
                        quienes decidir&aacute;n si el env&iacute;o puede ser
                        aceptado, considerando los montos y sus
                        caracter&iacute;sticas.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="45">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 38. Reclutamiento, Selección y Contratación
                        del Personal
                      </span>
                    </template>
                    <div>
                      <p>
                        Al momento de incorporar personas a
                        <strong>TENNOS&nbsp;BUSINESS,</strong> nos aseguramos de
                        seleccionarlos con mucha cautela y precisi&oacute;n,
                        tratando de captar los candidatos con las competencias,
                        formaci&oacute;n, probidad y experiencia necesaria para
                        asegurar el &eacute;xito futuro de la
                        organizaci&oacute;n. El proceso a utilizar se inicia
                        desde el &aacute;rea que necesita el personal, el
                        responsable llena el Formulario de
                        &ldquo;Requisici&oacute;n de Personal&rdquo; dando
                        inicio al siguiente proceso de evaluaci&oacute;n, al que
                        todos los aspirantes a alguna vacante de la empresa
                        tienen la obligaci&oacute;n de ser sometidos:
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Para cubrir una
                        vacante deber&aacute; ser reservada a primera instancia
                        para los empleados internos que re&uacute;nan los
                        requisitos de las mismas.
                      </p>
                      <p>
                        Seg&uacute;n las pol&iacute;ticas establecidas por
                        <strong>TENNOS&nbsp;BUSINESS.</strong> y de acuerdo a
                        las leyes nacionales, los aspirantes a ingresar en la
                        empresa deber&aacute;n cumplir con los siguientes
                        requisitos:
                      </p>
                      <p>A. Requisitos Generales</p>
                      <ul>
                        <li>
                          Ser mayor de edad (18 a&ntilde;os), seg&uacute;n
                          puesto de trabajo.
                        </li>
                        <li>
                          Gozar de una buena salud f&iacute;sica y mental,
                          dejando a opci&oacute;n de la empresa, el poderlo
                          comprobar mediante ex&aacute;menes cl&iacute;nicos.
                        </li>
                        <li>
                          No tener, al momento de la contrataci&oacute;n,
                          condenas de la justicia, y no tener en proceso ninguna
                          litis&nbsp;penal.
                        </li>
                        <li>
                          No haber sido despedido de trabajos anteriores de
                          forma
                        </li>
                        <li>
                          Haberse sometido al proceso de reclutamiento y
                          selecci&oacute;n establecido, con resultados positivos
                          en todas las etapas de la evaluaci&oacute;n.
                        </li>
                        <li>
                          Llenar los documentos establecidos en el mencionado
                          &nbsp;proceso &nbsp;de reclutamiento, tales como la
                          Solicitud de Empleo, u otros.
                        </li>
                        <li>
                          Someterse a las pruebas t&eacute;cnicas,
                          psicol&oacute;gicas y pruebas m&eacute;dicas mediante
                          ex&aacute;menes m&eacute;dicos, si se le requiriese,
                          sin costo alguno para el Apegado a las leyes de la
                          Rep&uacute;blica Dominicana, entre otras.
                        </li>
                        <li>
                          Cumplir con los requisitos espec&iacute;ficos
                          establecidos en la descripci&oacute;n del puesto.
                        </li>
                        <li>
                          Que sus referencias laborales y personales sean
                          adecuadas.
                        </li>
                        <li>
                          Someterse a un Per&iacute;odo Probatorio m&iacute;nimo
                          de 90 d&iacute;as, seg&uacute;n el puesto de trabajo,
                          sin perjuicio de lo establecido por el Art&iacute;culo
                          88, ordinal No.2, Art&iacute;culos 76 y 80, del
                          C&oacute;digo de trabajo.
                        </li>
                        <li>
                          Estar dispuesto(a) a cumplir con las disposiciones
                          administrativas, reglamentos, normas, pol&iacute;ticas
                          y reglas de seguridad establecida
                        </li>
                      </ul>
                      <ul>
                        <li>
                          Cumplir con el perfil humano de estilo y vida
                          organizada que establece la filosof&iacute;a del
                          grupo.
                        </li>
                        <li>
                          Que no trabaje para la organizaci&oacute;n en ese
                          momento, ning&uacute;n familiar o emparentado del
                          aspirante, salvo excepciones de la Direcci&oacute;n
                          General.
                        </li>
                      </ul>
                      <p>
                        B. Otros requisitos para el Personal T&eacute;cnico y de
                        Ventas:
                      </p>
                      <ul>
                        <li>
                          Poseer licencia de conducir, tipo 02, al d&iacute;a.
                        </li>
                        <li>
                          Poseer conocimientos b&aacute;sicos sobre cuidado y
                          prevenci&oacute;n de problemas mec&aacute;nicos.
                        </li>
                        <li>
                          Dominio de computadores y lenguajes bajo el ambiente
                          Windows.<strong></strong>
                        </li>
                      </ul>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Compromisos del Nuevo
                        Empleado, Una vez admitido, el nuevo empleado(a) se
                        compromete a:
                      </p>
                      <ul>
                        <li>
                          Cumplir con el horario de trabajo aceptado como
                          oficial en la compa&ntilde;&iacute;a.
                        </li>
                        <li>
                          Firmar los documentos establecidos como de entrada,
                          tales como Contratos Laborales y de Confidencialidad,
                          Acci&oacute;n de Personal, u otros.
                        </li>
                        <li>
                          Cursar el programa de Inducci&oacute;n establecido
                          para la posici&oacute;n, con una duraci&oacute;n
                          oficial de entre dos d&iacute;as a tres meses, de
                          acuerdo a las demandas del cargo.
                        </li>
                        <li>
                          Dejar constancia siempre por escrito, firmando todas
                          las condiciones econ&oacute;micas, horarios,
                          comisiones, incentivos, u otras, de la
                          contrataci&oacute;n final.
                        </li>
                        <li>
                          Abocarse al cumplimiento preciso de todos los
                          procedimientos t&eacute;cnicos, administrativos y
                          &eacute;ticos establecidos por la empresa.
                        </li>
                        <li>
                          Est&aacute; prohibido toda relaci&oacute;n de pareja
                          entre Si llegase &nbsp;a comprobarse una
                          relaci&oacute;n sentimental se deber&aacute;
                          desvincular uno de los emparentados.
                        </li>
                        <li>
                          Su contrato de trabajo haya sido detenido por
                          desahucio o renuncia, nunca por&nbsp;despido.
                        </li>
                        <li>
                          Siempre que sus dos &uacute;ltimas evaluaciones de
                          desempe&ntilde;o hayan sido con calificaci&oacute;n
                          m&iacute;nima de &ldquo;Buena&rdquo;.
                        </li>
                        <li>
                          Que no trabaje para la empresa en ese momento,
                          ning&uacute;n familiar o emparentado del aspirante,
                          salvo autorizaci&oacute;n de la
                          Direcci&oacute;n&nbsp;General.
                        </li>
                        <li>
                          Siempre que su nivel de competencia y capacidad haya
                          mejorado durante el tiempo que se mantuvo fuera de la
                          organizaci&oacute;n.
                        </li>
                        <li>
                          Siempre que dos Directores o Gerentes firmen,
                          autorizando su reintegro.
                        </li>
                      </ul>
                      <p></p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="46">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 39. Reuniones Ordinarias y Extraordinarias
                      </span>
                    </template>
                    <div>
                      <p>
                        En <strong>TENNOS&nbsp;BUSINESS,</strong> se han
                        establecido dos tipos de Reuniones:
                      </p>
                      <ul>
                        <li>
                          Reuniones ordinarias: Tales como la reuni&oacute;n de
                          ventas, reuni&oacute;n de alta gerencia,
                          reuni&oacute;n de apertura de Proyecto, reuniones con
                          clientes, de proyectos u otras.
                        </li>
                        <li>
                          Reuniones extraordinarias: Tales como actividades de
                          capacitaci&oacute;n, talleres, reuni&oacute;n con
                          Asesores, suplidores&nbsp;u otros.
                        </li>
                      </ul>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Es responsabilidad de
                        todos los empleados, acudir a aquellas a las cuales se
                        les convoquen, asumir los compromisos que all&iacute; se
                        acuerden, y dar respuesta en el tiempo establecido, de
                        los resultados y seguimientos que le sean asignados.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>De cada
                        reuni&oacute;n se debe levantar minutas, asistencias y
                        de ser necesario fotograf&iacute;as.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="47">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 40. Servicios y Beneficios del Personal
                      </span>
                    </template>
                    <div>
                      <p>
                        Para mantener la motivaci&oacute;n del personal, se
                        establecen los siguientes servicios y beneficios
                        marginales, adem&aacute;s de los definidos por el
                        C&oacute;digo de Trabajo:
                      </p>
                      <ul>
                        <li>
                          Plan de seguro m&eacute;dico en la ARS de su
                          elecci&oacute;n, garantiz&aacute;ndole su salud
                          f&iacute;sica y estabilidad emocional, plan de
                          pensiones y seguro de riesgos&nbsp;laborales.
                        </li>
                        <li>
                          Obtener todo tipo de capacitaci&oacute;n,
                          adiestramiento o entrenamiento que su puesto exija,
                          cubierto por la empresa seg&uacute;n
                          pol&iacute;tica&nbsp;establecida.
                        </li>
                        <li>
                          Asignaci&oacute;n de combustible, siendo &eacute;ste
                          parte de los beneficios marginales, se realiza
                          dependiendo de las funciones de la posici&oacute;n, de
                          la jerarqu&iacute;a de los Esta asignaci&oacute;n esta
                          especificada en la matriz de asignaci&oacute;n de
                          combustible. El beneficio de combustible podr&aacute;
                          ser variado o retirado por decisi&oacute;n unilateral
                          de la empresa.
                        </li>
                        <li>
                          Y los beneficios establecidos por la ley:
                          regal&iacute;a, bonificaci&oacute;n de ley, vacaciones
                          y otros para su protecci&oacute;n.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="48">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 41. Sueldos y Salarios
                      </span>
                    </template>
                    <div>
                      <p>
                        El empleado que entre a formar parte de cualquiera de
                        las empresas del grupo recibir&aacute; el sueldo
                        m&iacute;nimo establecido para el nivel del puesto y la
                        clasificaci&oacute;n de nuestra empresa. En todos los
                        casos, este sueldo podr&aacute; exceder del
                        m&iacute;nimo de ley, seg&uacute;n acuerdo previo entre
                        el empleado y Capital Humano, en atenci&oacute;n a
                        diferentes circunstancias de educaci&oacute;n,
                        competencias, horario, capacidad, experiencia,
                        desempe&ntilde;o, mercado laboral, etc. Y siempre con la
                        aprobaci&oacute;n, de la Direcci&oacute;n General La
                        revisi&oacute;n de salarios se har&aacute;:
                      </p>
                      <ul>
                        <li>Al aprobar el per&iacute;odo probatorio en la</li>
                        <li>
                          Cuando el empleado haya cumplido un a&ntilde;o, o en
                          su fecha aniversario, lo cual estar&aacute; basado en
                          el reporte de la evaluaci&oacute;n del
                          desempe&ntilde;o, realizado por el superior inmediato
                          y la dependencia de Capital
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="49">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 42. Uso de carnets de Identificación</span
                      >
                    </template>
                    <div>
                      <ul>
                        <li>
                          Todo el personal de
                          <strong>TENNOS&nbsp;BUSINESS,</strong> deber&aacute;
                          portar siempre durante la jornada de trabajo, el
                          carnet de la&nbsp;empresa.
                        </li>
                        <li>
                          Personal sub-contratado: deben portar durante toda su
                          jornada y el desarrollo de todo el proyecto, el
                          carn&eacute;t de identidad de
                          &ldquo;contratista&rdquo; numerado, para su
                          identificaci&oacute;n en cada proyecto, de no cumplir
                          se le notificar&aacute; a la empresa contratista, a
                          los fines de tomar las medidas que se
                          consideren&nbsp;pertinentes.
                        </li>
                        <li>
                          Al final de la jornada de contratista, los
                          carn&eacute;ts deben ser devueltos al supervisor
                          inmediato, de ser posible, y solicitarlo al d&iacute;a
                          siguiente, para coloc&aacute;rselo durante la
                          duraci&oacute;n del d&iacute;a de&nbsp;trabajo.
                        </li>
                        <li>
                          El uso del carn&eacute;t es obligatorio para toda
                          persona que trabaje con y para las empresas de
                          <strong>TENNOS&nbsp;BUSINESS,</strong>
                        </li>
                        <li>
                          Al momento de concluir el contrato de trabajo, el ex
                          empleado debe retornar este&nbsp;documento.
                        </li>
                        <li>
                          En caso de p&eacute;rdida, deber&aacute; reportarlo de
                          manera inmediata a Capital Humano, para evitar el
                          ingreso de personas externas a la instituci&oacute;n.
                          De la misma manera, se le descontar&aacute; v&iacute;a
                          n&oacute;mina la reposici&oacute;n previa
                          autorizaci&oacute;n, notificaci&oacute;n y tomando en
                          cuenta el costo del pl&aacute;stico a la fecha.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="56">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 43. Uso de las herramientas Tecnológicas y
                        Acceso a internet.
                      </span>
                    </template>
                    <div>
                      <p>
                        <strong>TENNOS&nbsp;BUSINESS,</strong>&nbsp; restringe
                        mediante la&nbsp; presente pol&iacute;tica, el uso de
                        Internet para asuntos personales en horario laborable,
                        los empleados que necesiten Internet podr&aacute;n
                        utilizarlo por la naturaleza de las funciones, pero,
                        para fines personales o particulares solo deber&aacute;n
                        acceder a la red en horario no laborable.
                      </p>
                      <p>
                        Se proh&iacute;be el acceso a p&aacute;ginas de dudosa
                        denominacion durante las horas de trabajo, a menos que
                        sean consultas t&eacute;cnicas, tambi&eacute;n se
                        proh&iacute;be el acceso a p&aacute;ginas
                        pornogr&aacute;ficas, p&aacute;ginas de descarga de
                        pel&iacute;culas, videos, m&uacute;sica, etc durante la
                        jornada laboral. Quienes sean sorprendidos en esta
                        actividad, se les quitar&aacute; el acceso desde su
                        computador a esa opci&oacute;n tecnol&oacute;gica y
                        podr&iacute;an ser amonestados.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Queda terminantemente
                        prohibido el acceso a p&aacute;ginas que violenten las
                        buenas costumbres &eacute;ticas y morales de la
                        compa&ntilde;&iacute;a, as&iacute; como bajar o
                        presenciar pel&iacute;culas, cruzar informaci&oacute;n
                        confidencial e institucional sin previa
                        autorizaci&oacute;n escrita de su superior, como
                        cualquier otra pr&aacute;ctica, que pueda entenderse
                        como desleal o amoral.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>La violaci&oacute;n
                        de estas pr&aacute;cticas puede ser causal de despido.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="50">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 44. Uso de Materiales, Equipos y Herramientas
                      </span>
                    </template>
                    <div>
                      <p>
                        Los materiales, equipos y herramientas (tales como
                        laptops, veh&iacute;culos, pizarras, herramientas
                        t&eacute;cnicas, sillas, productos en existencia del
                        almac&eacute;n, u otros) que pertenecen a
                        <strong>TENNOS&nbsp;BUSINESS,</strong> se pueden
                        utilizar para la realizaci&oacute;n de trabajos&nbsp;
                        que as&iacute; lo&nbsp; requieran. Con dos d&iacute;as
                        de anticipaci&oacute;n se debe reportar la necesidad,
                        llenando una solicitud de dichas piezas, equipos, y/o
                        herramientas al encargado de esta &aacute;rea, el cual
                        le har&aacute; entrega al supervisor y &eacute;ste a su
                        vez al &aacute;rea de compras de la empresa. Una vez
                        concluyan los &nbsp;trabajos, estas deben&nbsp; ser
                        devueltas nuevamente al &aacute;rea de log&iacute;stica,
                        el cual deber&aacute; revisarlas antes de recibirlas y
                        darle entrada nuevamente en almac&eacute;n. En caso de
                        que falte alg&uacute;n equipo, pieza o
                        herramienta,&nbsp; el&nbsp; responsable directo
                        deber&aacute; reponerla o hacerse responsable de su
                        reposici&oacute;n.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Cada empleado es
                        responsable del adecuado uso y cuidado de los equipos,
                        materiales y herramientas que tenga bajo su
                        responsabilidad en la realizaci&oacute;n de la tarea.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="52">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 45. Uso del Teléfono:
                      </span>
                    </template>
                    <div>
                      <p>
                        Dada la naturaleza de la organizaci&oacute;n, y de la
                        importancia que reviste para los trabajos la
                        comunicaci&oacute;n telef&oacute;nica, se establecen
                        normas en el uso del tel&eacute;fono entre los
                        empleados. El servicio del tel&eacute;fono es costoso
                        pero indispensable en la realizaci&oacute;n de nuestros
                        trabajos, por lo que:
                      </p>
                      <ul>
                        <li>
                          Las llamadas laborales de larga distancia, se deben
                          solicitar a la persona responsable en el departamento,
                          el cual posee una asignaci&oacute;n en la plataforma
                          de la central telef&oacute;nica siempre con la
                          autorizaci&oacute;n del supervisor&nbsp;inmediato.
                        </li>
                        <li>
                          La empresa le asigna un monto mensual a los usuarios
                          de flotas dependiendo de la jerarqu&iacute;a de su
                          posici&oacute;n y sus funciones, el excedente de esos
                          montos ser&aacute; cubierto por los usuarios y
                          descontado por n&oacute;mina, previa
                          notificaci&oacute;n y autorizaci&oacute;n.
                        </li>
                        <li>
                          Los celulares personales y aparatos de flota deben
                          usarse con timbre discreto, bajo y de tono
                          profesional, o mantenerse en vibraci&oacute;n, durante
                          las horas de trabajo, reuniones y dentro de de la
                          oficina.
                        </li>
                        <li>
                          Las fotos de perfiles en los tel&eacute;fonos de la
                          flota, as&iacute; como en Whatsapp deben cumplir con
                          un criterio profesional y de buenas&nbsp;costumbres.
                        </li>
                        <li>
                          En todo lo posible se evitar&aacute; contestar
                          llamadas, durante las reuniones.
                        </li>
                        <li style="text-align: justify">
                          No debe usarse el tel&eacute;fono o celular en forma
                          indiscriminada, ni durante mucho&nbsp;tiempo.
                        </li>
                        <li>
                          Las llamadas personales deben ser reducidas al
                          m&iacute;nimo.
                        </li>
                        <li>
                          Los aparatos de flota deben ser devueltos una vez
                          concluya el contrato de Siempre previa firma.
                        </li>
                        <li>
                          Es responsabilidad de los empleados velar por el buen
                          uso y cuidado de los aparatos de flota bajo su cargo.
                          En caso de maltrato o p&eacute;rdida del aparato se le
                          cargar&aacute; el costo y se le descontar&aacute;
                          v&iacute;a n&oacute;mina, previa notificaci&oacute;n y
                          autorizaci&oacute;n.
                        </li>
                        <li>
                          Existe un grupo de Whatsapp institucional, al cual
                          ser&aacute;n a&ntilde;adidos los empleados con su
                          n&uacute;mero de flota, cuyo fin es profesional y para
                          comunicaci&oacute;n interna, por lo tanto debe ser
                          utilizado con moderaci&oacute;n, manteniendo el
                          respeto,&nbsp; la prudencia y en horarios prudentes,
                          su uso inadecuado puede ser motivo de un llamado a
                          atenci&oacute;n.
                        </li>
                      </ul>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="53">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 46. Uso, asignación y Custodia de los
                        Vehículos Institucionales
                      </span>
                    </template>
                    <div>
                      <p>
                        La utilizaci&oacute;n de veh&iacute;culos por los
                        Ejecutivos de ventas, Directores, Gerentes, Encargados,
                        T&eacute;cnicos, Supervisores y Choferes, es
                        indispensable para la realizaci&oacute;n de las
                        actividades y responsabilidades de la empresa.
                      </p>
                      <p>
                        En el inter&eacute;s de que los veh&iacute;culos de la
                        empresa sean adecuadamente utilizados, de forma que el
                        patrimonio de la empresa sea resguardado por todos sus
                        empleados, establecemos el siguiente reglamento:
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Los veh&iacute;culos
                        est&aacute;n asignados acorde a los trabajos y con
                        responsabilidad claramente especificada. La
                        asignaci&oacute;n de un veh&iacute;culo, a trabajos de
                        un determinado proyecto, diligencia, compra u otros,
                        debe ser notificada al encargado del &aacute;rea
                        correspondiente, por el superior inmediato.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Los usuarios son los
                        responsables de gestionar los mantenimientos preventivos
                        y correctivos relacionados con los veh&iacute;culos del
                        &aacute;rea, siempre en la casa representante del mismo;
                        dicho mantenimiento se registra en la ficha de
                        mantenimiento.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3: </strong>Cada veh&iacute;culo
                        debe estar identificado y fichado por la empresa, y
                        poseer un expediente de seguimiento mec&aacute;nico y de
                        seguros, para su correcta administraci&oacute;n.
                        Est&aacute; prohibido transportar personas ajenas a la
                        empresa en los &nbsp;veh&iacute;culos pertenecientes a
                        la misma.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 4: </strong>Para poder asignar un
                        veh&iacute;culo, los empleados deben ser conocidos como
                        &ldquo;personal fijo&rdquo; de la empresa, y el
                        supervisor velar&aacute; porque as&iacute; sea. Capital
                        Humano constatar&aacute; que el colaborador(a) posea
                        licencia de conducir al d&iacute;a. Al recibir el
                        veh&iacute;culo, el empleado debe velar porque le sea
                        realizada la inspecci&oacute;n de lugar, a los fines de
                        evitar los imprevistos y debe cerciorarse de que se
                        encuentre en buen estado, verific&aacute;ndole nivel de
                        agua, aceite, aire en los neumaticos y&nbsp;
                        dem&aacute;s detalles necesarios para su buen
                        funcionamiento. Al concluir la jornada, el empleado debe
                        notificar su llegada y entregar el veh&iacute;culo y sus
                        llaves al empleado responsable de los mismos.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 5: </strong>Todos los
                        veh&iacute;culos propiedad de la empresa, poseen GPS
                        para control en el uso indiscriminado. Los
                        veh&iacute;culos de los Ejecutivos de Ventas poseen un
                        GPS para control y seguimiento de su trabajo dentro de
                        su jornada laboral. Los veh&iacute;culos personales de
                        empleados (siempre previa autorizaci&oacute;n) tienen
                        instalados GPS comoparte de los beneficios marginales,
                        dicho GPS le ser&aacute; retirado al momento de poner
                        fin al contrato de trabajo.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 6: </strong>Todos los
                        veh&iacute;culos propiedad de la empresa utilizados para
                        mensajeria deber&aacute;n dormir en la empresa, a menos
                        que por razones de trabajo previamente notificadas, sea
                        diferente. El empleado que utiliza un veh&iacute;culo es
                        responsable de su integridad y buen funcionamiento.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 7: </strong>La violaci&oacute;n a
                        esta pol&iacute;tica le implica al responsable del
                        veh&iacute;culo el pago de los costos que por
                        negligencia o mal uso se puedan incurrir y es causal de
                        Despido, seg&uacute;n el art&iacute;culo 88 del
                        C&oacute;digo de Trabajo.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="54">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 47. Vacaciones del Personal
                      </span>
                    </template>
                    <div>
                      <p>
                        Las vacaciones se otorgar&aacute;n a cada empleado
                        despu&eacute;s de haber trabajado durante un
                        per&iacute;odo de un a&ntilde;o de manera
                        ininterrumpida, seg&uacute;n Art. 177 al Art. 190 del
                        c&oacute;digo laboral. El per&iacute;odo de vacaciones
                        para los que cumplan su primer a&ntilde;o ser&aacute; de
                        14 d&iacute;as laborables, y el empleado podr&aacute;
                        acumularlas hasta por 2 a&ntilde;os.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Se establece periodo
                        de vacaciones colectivas en Semana Santa y en las
                        festividades navide&ntilde;as, los cuales ser&aacute;n
                        descontados de la cantidad de d&iacute;as
                        correspondientes a las vacaciones del empleado
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>Las vacaciones
                        solicitadas deber&aacute;n ser mayor a 5 d&iacute;as y
                        no podr&aacute;n ser fraccionadas en m&aacute;s de 3
                        ocasiones.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 3: </strong>Se solicitar&aacute;n
                        y planearan en coordinaci&oacute;n con el superior
                        inmediato, para ello se considerar&aacute; el flujo
                        normal de los trabajos y disponibilidades del
                        departamento <strong>TENNOS&nbsp;BUSINESS,</strong>
                        En ocasiones consideran el otorgar el disfrute de
                        vacaciones colectivas a todo el personal, si por alguna
                        raz&oacute;n se ofrecen y los d&iacute;as son cambiados
                        o no disfrutados por trabajo u otros, se le
                        repondr&aacute;n, siendo esta solicitud sometida al
                        supervisor inmediato, a los fines de que pueda
                        planificar estas reposiciones de vacaciones de su
                        personal, con anticipaci&oacute;n.
                      </p>
                      <p>
                        Fuera de las vacaciones colectivas no se contempla el
                        adelanto de vacaciones que el empleado no haya generado.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
                <li>
                  <el-collapse-item name="55">
                    <template slot="title">
                      <span class="boldTitle"
                        >Artículo 48. Viáticos: (Viajes, Traslados, Hoteles,
                        Imprevistos y Dietas)
                      </span>
                    </template>
                    <div>
                      <p>
                        El personal de las diferentes empresas, tiene acceso a
                        una l&iacute;nea de prestaciones otorgadas seg&uacute;n
                        la jerarqu&iacute;a de los cargos, las funciones y
                        responsabilidades a desempe&ntilde;ar. Estas
                        asignaciones se realizan en el momento de la
                        discusi&oacute;n del contrato de trabajo y, son
                        ajustadas seg&uacute;n la situaci&oacute;n de la
                        compa&ntilde;&iacute;a y los requerimientos del puesto:
                        Las posiciones favorecidas con este modelo de recompensa
                        son: Director General, Directores, Gerentes, Encargados
                        Departamentales y Personal T&eacute;cnico, seg&uacute;n
                        tabla administrativa aprobada por niveles
                        jer&aacute;rquicos.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 1: </strong>Queda prohibida la
                        asignaci&oacute;n de dietas, o vi&aacute;ticos fuera de
                        esta clasificaci&oacute;n o para la realizaci&oacute;n
                        de trabajos en la zona metropolitana. Se entiende por
                        zona metropolitana el espacio&nbsp;
                        geogr&aacute;fico&nbsp; delimitado&nbsp; por los peajes
                        del Gran Santo Domingo.
                      </p>
                      <p>
                        <strong>P&aacute;rrafo 2: </strong>En casos
                        extraordinarios, por jornadas especiales u otros, los
                        Directores Gerentes y Encargados de &aacute;rea
                        podr&aacute;n solicitar que les sea asignado algunos
                        vi&aacute;ticos extraordinarios a un equipo o puestos de
                        trabajo, para ello deben procurar la aprobaci&oacute;n
                        necesaria.
                      </p>
                    </div>
                  </el-collapse-item>
                </li>
              </el-collapse>
            </ul>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "1"
    };
  }
};
</script>

<style lang="scss" scoped>
.boldTitle {
  font-weight: bold;
}
</style>
